/**
 * @module 英語文言定義
 */
import en from 'vuetify/src/locale/en.ts';
export const eng = {
  ...en,
  お客様Webサイト: 'Customer Web Site',
  English: '日本語',
  // 既存サービス
  既存サービス: {
    外出ALSOK警備: 'Away-ALSOK Security Mode',
    在宅ALSOK警備: 'Home-ALSOK Security Mode',
    侵入: 'Intruder',
    非常: 'Emergency',
    火災: 'Fire',
    ガス: 'Gas',
    ライフリズム: 'Life Rhythm',
    解除モード: 'Deactivated Mode',
    IDカードキー操作: 'ID Card/Key Operations',
    外出: 'Away',
    在宅: 'Home',
    解除ボタン: 'Deactivate',
    侵入警報: 'Intruder alarm',
    火災警報: 'Fire alarm',
    ガス警報: 'Gas alarm',
    非常警報: 'Emergency alarm',
    ライフリズム警報: 'Life Rhythm alarm',
    電源異常警報: 'power abnormality alarm',
    電池切れ警報: 'low-battery alarm',
  },
  ログイン: {
    ログイン: 'Login',
    パスワード: 'password',
    ユーザーID: 'userid',
    ユーザーIDを記憶する: 'Remember me',
    ログインボタン: 'Login',
    新規メインユーザー登録: 'New main user registration',
    パスワードを忘れた場合: 'Forgot your password?',
    アカウントロック: 'account lock button',
  },
  // コード
  コード: {
    サービス種別: {
      ホームセキュリティオンライン監視プラン: 'Home Security (Online security)',
      ホームセキュリティ依頼かけつけプラン: 'Home Security (Self security)',
      ホームセキュリティセルフ監視プラン:
        'Home Security (Self security(emergency assistance on demand impossible))',
      カメラオンラインプラン: 'Camera (Online security)',
      カメラ依頼かけつけプラン: 'Camera (Self security)',
      カメラセルフ監視プラン: 'Camera (Self security(emergency assistance on demand impossible))',
    },
    警備情報: {
      外出ALSOK警備中: 'ALSOK security away mode',
      在宅ALSOK警備中: 'ALSOK security home mode',
      外出セルフ警備中: 'self security away mode',
      在宅セルフ警備中: 'self security home mode',
      警備解除中: 'Security deactivated mode',
      ユーザ点検中: 'User checking mode',
    },
    セキュリティの更新状況: {
      正常: 'Normal',
      現在と同じ警備ステータス: '',
      戸締まり異常発生中: 'Lock-up abnormality occurring',
    },
    警報センサー状態: {
      異常なし: 'No abnormalities',
      発報中: 'Alarm in progress',
    },
    見守り方法: {
      使用しない: 'Do not use',
      定期連絡: 'Regular communication',
      異常通知: 'Abnormality notification',
      定刻連絡: 'Scheduled communication',
    },
    警報ユニット状態: {
      正常: 'Normal',
      異常: 'Abnormal',
      停止: 'E停止',
    },
    性別: {
      未指定: 'Unspecified',
      男性: 'Male',
      女性: 'Female',
    },
    カメラユーザ種別: {
      メインユーザ: 'Main user',
      サブユーザ: 'Sub-user',
    },
    承認区分: {
      承認: 'Approve',
      否認: 'Reject',
    },
    通知状況: {
      通知なし: 'No notifications',
      警報通知: 'Alarm notification',
      警備セット解除通知: 'Security activated/deactivated notification',
      状態信号通知: 'Status signal notification',
      ALSOKからのお知らせ: 'Message from ALSOK',
    },
    ニックネーム登録結果: {
      正常: 'Normal',
      登録不可: 'Registration not available',
    },
    ワンタイムURL状態: {
      正常: 'Normal',
      存在しないURL: 'Non-existent URL',
    },
    警報種別: {
      警報なし: 'No alarms',
      侵入: 'Intruder',
      非常: 'Emergency',
      火災: 'Fire',
      ガス: 'Gas',
      ライフリズム: 'Life Rhythm',
      電池: 'Battery',
      機器異常: 'Device error',
      設備: 'Facility',
    },
    OAuth認証エラーコード: {
      認証成功: 'Authentication successful',
      認証失敗: 'Authentication failed',
    },
    サービス追加エラーコード: {
      登録完了: 'Registration completed',
      登録失敗: 'Registration failed (input information is incorrect)',
      メインユーザ登録済み: 'Main user registered',
    },
    利用プランID: {
      オンライン監視プラン: 'Online security',
      依頼かけつけプラン: 'Self security',
      セルフ監視プラン: 'Self security(emergency assistance on demand impossible) ',
      カメラ依頼かけつけプラン: 'Emergency assistance on demand possible',
      カメラセルフ監視プラン: 'None',
    },
    ユニット運用状態: {
      未開始: 'Not started',
      警備中: 'On guard',
      中断中: 'Interrupted',
      解約: 'Cancellation of contract',
      その他: 'Other (Error)',
    },
    機種ID: {
      S_860_GS: 'S_860_GS',
      S_728_HS: 'S_728_HS',
      S_860M_GSM: 'S_860M_GSM',
      S_861_G6: 'S_861_G6',
      CU_861_G6: 'CU_861_G6',
      S_729: 'S-729',
      S_730: 'S-730',
      eCame3: 'eCame3',
      指定なし: 'No designation',
    },
    対象地区ユーザ種別: {
      メインユーザ: 'Main user',
      サブユーザ: 'Sub-user',
    },
    ユーザー種別: {
      メインユーザ: 'Main user',
      サブユーザ: 'Sub-user',
    },
    アカウント登録状態: {
      本登録: 'Definitive registration',
      仮登録: 'Provisional registration',
    },
    ユーザーロック状態: {
      ロックあり: 'Locked',
      ロックなし: 'Not locked',
    },
    運用状態: {
      未開始: 'Not started',
      警備中: 'On guard',
      中断中: 'Interrupted',
      解約: 'Cancellation of contract',
      その他エラー: 'Other (Error)',
    },
    カメラ運用状態: {
      未開始: 'Not started',
      警備中: 'On guard',
      中断中: 'Interrupted',
      解約: 'Cancellation of contract',
      その他エラー: 'Other (Error)',
    },
    ログイン結果: {
      ログイン成功: 'Login successful',
      認証が必要: 'Two-step authentication is required',
      ログイン失敗: 'Login failed',
    },
    お知らせ通知対象ユーザー種別: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
      全ユーザー: 'All users',
      指定ユーザー: 'Specified user',
      指定なし: 'No designation',
    },
    ユニット種別: {
      警備ユニット: 'Security unit',
      カメラ: 'Camera',
    },
    送信状態: {
      未送信: 'Unsent',
      送信済み: 'Sent',
      エラー: 'Error',
      リトライ: 'Retry',
    },
    同居家族続柄: {
      本人: 'The person in question',
      夫: 'Husband',
      妻: 'Wife',
      子: 'Child',
      孫: 'Grandchild',
      父: 'Father',
      母: 'Mother',
      兄: 'Elder brother',
      姉: 'Elder sister',
      弟: 'Younger brother',
      妹: 'Younger sister',
      祖父: 'Grandfather',
      祖母: 'Grandmother',
      その他: 'Other',
      未選択: 'Not selected',
    },
    カメラ連携結果: {
      連携完了: 'Linkage completed',
      連携失敗: 'Linkage failed',
      連携途中: 'Linkage in progress',
      デバイスID誤り: 'Device ID incorrect',
    },
    ユーザ権限種別対象地区: {
      警備操作: 'Security operation',
      かけつけ依頼: 'Emergency assistance on demand',
      通知履歴: 'Notification history',
      機器制御: 'Device control',
      ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
      ニックネーム設定: 'Nickname setting',
      IDカードキー情報設定: 'ID/Card key information setting',
      見守り情報配信設定: 'Monitoring information delivery setting',
      戸締り確認警報確認: 'Lock-up/Alarm check',
      在宅対象設定: 'Subarea setting',
      ユーザ管理: 'User management',
      緊急連絡先: 'Emergency contact',
      メインユーザ: 'Main user',
    },
    ユーザ権限種別カメラ: {
      カメラ映像: 'Camera image',
      かけつけ依頼: 'Emergency assistance on demand',
      通知履歴: 'Notification history',
      ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
      ニックネーム設定: 'Nickname setting',
      ユーザ管理: 'User management',
      緊急連絡先: 'Emergency contact',
      メインユーザ: 'Main user',
    },
    通知配信設定種別対象地区: {
      警備操作: 'Security operation',
      侵入: 'Intruder',
      火災: 'Fire',
      火災復旧: 'Fire - Recovery',
      ガス: 'Gas',
      ガス復旧: 'Gas - Recovery',
      非常救急: 'Emergency/First aid',
      非常救急復旧: 'Emergency/First aid - Recovery',
      ライフリズム: 'Life Rhythm',
      ライフリズム復旧: 'Life-Rhythm - Recovery',
      設備: 'Facility',
      設備復旧: 'Facility - Recovery',
      電池切れ: 'low-battery',
      電池切れ復旧: 'Dead battery - Recovery',
      機器異常: 'Device error',
      機器異常復旧: 'Device error - Recovery',
      お知らせ: 'Announcement',
      通知有無: 'Presence/absence of notifications',
    },
    通知配信設定種別カメラ: {
      動体検知ローバッテリー: 'Motion detection, Low battery',
      通知有無: 'Presence/absence of notifications',
    },
    検知種別: {
      動体検知ローバッテリー: 'Motion detection, Low battery',
    },
    曜日: {
      日: 'Sun',
      月: 'Mon',
      火: 'Tue',
      水: 'Wed',
      木: 'Thu',
      金: 'Fri',
      土: 'Sat',
    },
  },
  // メッセージ一覧
  メッセージ一覧: {
    FECU01ログイン画面: {
      E0001: 'Be sure to enter your user ID (email address).',
      E0004: 'Be sure to enter your password.',
      E0007: 'Failed to log in.\n(Error Code: FE-CU1-E0007)',
      E0008:
        'Biometric authentication of your smartphone/tablet is disabled and cannot be used.\nCheck the settings of your smartphone/tablet.\n(Error Code: FE-CU1-E0008)',
      E0010:
        'Authentication failed.\nPasscode authentication will not be available.\n(Error Code: FE-CU1-E0010)',
      E0011:
        'The passcode is incorrect.\nPlease enter the passcode again.\n(Error Code: FE-CU1-E0011)',
      C0001:
        'Terms of Use and Privacy Policy is displayed in the web browser.\nDo you want to display The Terms of Use and Privacy Policy?',
      C0002:
        'Password re-registration (user ID) is displayed in the web browser.\nDo you want to display The Password re-registration (user ID)?',
    },
    FENV01ログイン画面: {
      E0001:
        'Unable to communicate with the server.\nCheck the network settings and try again.\n(Error Code:FE-NV1-E0001)',
    },
    FECU02トップ画面: {
      E0001: 'Your login has expired.\nPlease log in again.\n(Error Code: FE-CU2-E0001)',
      //  'There was a login to your account from another terminal or browser.\nTo use this terminal, log in again.\n(Error Code: FE-CU2-E0001)',
      E0002:
        'Logged out due to inactivity for a certain period of time.\nPlease log in again.\n(Error Code: FE-CU2-E0002)',
      E0003: 'A system error has occurred.\n(Error Code: FE-CU2-E0003)',
      E0004: 'The content has been updated.\nRefresh the screen again.\n(Error Code: FE-CU2-E0004)',
      E0005:
        'Failed to start the application.\nPress the phone number buttons again.\n(Error Code: FE-CU2-E0005)',
      C0001: '{buttonName} is completed.',
      E0006:
        'Failed to start the application.\nPress the phone number buttons again.\n(Error Code: FE-CU2-E0006)',
      E0007:
        'A system error has occurred.\n(Error Code: {0})\nPlease contact ALSOK Sales.\n(Error Code: FE-CU2-E0007)',
      E0008:
        'Failed to communicate.\nPlease wait for a while and try again.\n(Error Code: FE-CU2-E0008)',
      E0009:
        'Communication between the security unit and the server failed.\nPlease contact the ALSOK office in charge.\n(Error Code: FE-CU2-E0009)',
      E0011:
        'An error was returned from the security unit.\nPerform the operation again. \n(Error Code: FE-CU2-E0011)',
    },
    FECU03二段階認証画面: {
      E0001:
        'Your authorization code is incorrect. \nEnter the authorization code again.\n(Error Code: FE-CU3-E0001)',
      E0002: 'Be sure to enter your authorization code.',
    },
    FECU04パスワード初期化画面ユーザーID入力: {
      E0001: 'Be sure to enter your user ID (email address).',
      E0004: 'Be sure to enter the confirmation user ID (email address).',
      E0007: 'The user ID (email address) does not match the confirmation user ID (email address).',
      C0001:
        'Initialize the password. Enter the registered user ID (email address).\nEmails containing a one-time URL will be sent to the email address you entered. \nPlease access the one-time URL and perform the procedure.',
      E0008: 'The format of the user ID (email address) is incorrect.',
      E0009: 'The format of the confirmation user ID (email address) is incorrect.',
      E0010: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU4-E0010)',
    },
    FECU05パスワード初期化画面秘密の質問: {
      C0001:
        'Identity verification is performed to initialize the password. Enter the answer to the secret question that you set during user registration.\nIf the main user forgets the answer to the secret question, please contact the ALSOK office in charge.\nIf a sub-user forgets the answer to the secret question, the user must be re-registered. Please ask the main user.',
      E0001: 'Be sure to enter your answer.',
      E0003: 'The answer is incorrect.\n(Error Code: FE-CU5-E0003)',
      E0004:
        'Your account has been locked because you made a certain number of mistakes when answering the secret question.\n(Error Code: FE-CU5-E0004)',
      E0005: 'Please enter your answer in hiragana.',
    },
    FECU06パスワード初期化画面パスワード再登録: {
      C0001:
        'Reset your password.\nSet a password that is difficult to guess.\nThe password must be at least eight characters in length, containing at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      C0002: 'The content you entered will be registered.\nOK?',
      E0001: 'Be sure to enter a new password.',
      E0003: 'Be sure to enter a confirmation password.',
      E0005: 'The new password does not match the confirmation password.',
      E0006:
        'Re-registration processing failed.\nPlease register again.\n(Error Code: FE-CU6-E0006)',
      E0008:
        'The new password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0010:
        'The confirmation password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0011: 'For the password, enter eight characters or more.',
      E0012:
        'Re-registration processing failed.\nPlease enter a secret question from the URL in the e-mail and set a new password.\n（Error Code: FE-CU6-E0012）',
    },
    FECU07トップ画面: {
      C0001:
        'On the top screen, you can perform the following operations according to the contents of your contract.\n- Security operation\n　You can activate or deactivate security.\n　The Select Target Area button allows you to select the target area where security operations are performed and set the subarea for each area.\n　To change the security status, select the security status you want to change from ""Away/Home/Deactivate"" or ""ALSOK/Self"" and press the ""Change Security Status"" button.\n- Home Security button\n　Displays the screen on which you can perform various operations related to home security. (If you have a contract for multiple areas, the screen for selecting the area to operate is displayed.)\n- Camera button\n　Displays the screen on which you can perform various operations related to the camera. (If you have a contract for multiple cameras, the screen for selecting the camera to operate is displayed.)\n- Add Service button\n　Displays the screen on which you can add services to be used in the application or website.\n- Health Consultation, etc. button\n　Press this button to check the contact information before contacting us for health consultations, etc.\n\nMessages from ALSOK are displayed at the bottom of the screen, so please check the messages.',
      C0002:
        'Security was deactivated in {0} of {1} areas.\nAreas specified in the following are already deactivated.\n- Target areas: {2}',
      C0003: 'Security has been started in {0} of {1} areas.\n',
      C0004:
        'Security has been started in {0} of {1} areas.\nSecurity could not be started in some areas due to the following problem.\n- Target areas: {2}\nAn error was returned from the security unit.\nPerform the operation again.',
      C0005:
        'Security could not be started in some areas due to the following problem.\n\n- Target areas: {0}\n　The lock-up status is abnormal.\n　Please check the lock-up.\n',
      C0006:
        'Security has been started in {0} of {1} areas.\nSecurity could not be started in some areas due to the following problem.\n　- Target areas: {2}\n　　An error was returned from the security unit.\n　　Perform the operation again.\n- Target areas: {3}\n　The lock-up status is abnormal.\n　Please check the lock-up.\nFor the specified areas in the following, the security status could not be changed.\nAfter changing to the deactivated status, perform a security operation or check your contract type.\n　- Target areas: {4}',
      C0007: 'Change the security status.\nOK?',
      C0008: 'Registration is completed.',
      C0011: 'Security was deactivated in {0} of {1} areas.\n',
      C0017:
        'Add a service screen is displayed in the web browser.\nAt this time, you will be logged out of the application.\nDo you want to display the Add a service screen?',
      E0001:
        'A system error has occurred.Please contact ALSOK Sales.\n（Error Code:：FE-CU7-E0001）',
      E0002:
        'Failed to communicate.\nPlease wait for a while and try again.\n(Error Code: FE-CU7-E0002)',
      E0003:
        'Communication between the security unit and the server failed.\nPlease contact the ALSOK office in charge.(Error Code: FE-CU7-E0003)',
      E0004: 'Failed to change the security status.',
      E0005: 'Setup failed.\nPlease perform the setup again.',
      E0006: 'Failed to acquire subarea information.\nPlease perform the operation again.',
      E0007: 'Failed to update subarea information.\nPlease perform the operation again.',
    },
    FECU08ホームセキュリティ画面: {
      C0001:
        'A list of target areas registered to the current user is displayed.\nIcons displayed for each target area indicate the functions the user can use in that area.\nYou can check the details by pressing each target area.\n\nThe Notification History (within 24 hours) tab displays notifications for the listed target areas.',
      C0002: 'The notification history cannot be viewed due to a lack of authorization.',
    },
    FECU09対象地区詳細画面: {
      C0001:
        'Current information for the target area is displayed.You can check detailed information by pressing each button that is displayed according to the contents of your contract.\n\n- User Security Operation button\nYou can perform security operations with respect to the target area. You can also check the Alarm and Lock-up status from here.\n- Request Emergency Assistance button\nYou can request ALSOK to rush to the target area (for a fee).\n- Notification History button\nYou can check the history of notifications sent to your email address.\n- Inquiry for ALSOK button\nYou can check the contact information for inquiries.\n- Set Target Areas\nOpens the setting screen for target areas.\n- Device Control button\nYou can remote-control devices installed in the target area.\n\nThe Notification History (within 24 hours) tab displays notifications for the target area. (This tab is not displayed if you do not have authority for Notification/Notification History.)',
      E0003:
        'Communication between the security unit and the server failed.\nPlease contact the ALSOK office in charge.\n(Error Code: FE-CU9-E0003)',
    },
    FECU10ユーザー警備操作画面: {
      C0001:
        'You can perform security operations for the target area.\nTo change the security status, select the security status you want to change from ""Away/Home/Deactivate"" or ""ALSOK/Self"" and press the ""Change Security Status"" button.\nIn case of a lock-up abnormality, you cannot switch the security status.\nAlso, you cannot switch to the same security status as the current one.\n\nYou can check the abnormality that is currently occurring by pressing the Check Alarm or Check Lock-up button.\nYou can change the area where home security is performed by pressing the Set Subarea button and then selecting the subarea.',
      C0002: 'The specified area is already deactivated.',
      C0003: 'The security status has been changed.',
      C0004:
        'The lock-up status is abnormal.\nPlease check the lock-up.(If you have a contract for multiple areas, please check that the common areas are locked.)',
      C0005: 'Failed to change the security status.',
      C0006: 'Change the security status.\nOK?',
      C0007: 'The security status has been changed.',
      C0008: 'Registration is completed.',
      E0001:
        'An error was returned from the security unit.\nPerform the operation again. \n(Error Code: FE-CU10-E0001)',
      E0002:
        'Failed to communicate.\nPlease wait for a while and try again. \n(Error Code: FE-CU10-E0002)',
      E0005:
        'Failed to apply subarea. Please perform the operation again. \n(Error Code: FE-CU10-E0005)',
      E0007:
        'The security status could not be changed.\nThe security status may have already been deactivated.Check the security status.\n(Error Code: FE-CU10-E0007)',
      E0008:
        'The lock-up status is abnormal.\nPlease check the lock-up. (If you have a contract for multiple areas, please check that the common areas are locked.)\n(Error Code: FE-CU10-E0008)',
      E0009:
        'The security status could not be changed.\nAfter changing to the deactivated status, perform a security operation or check your contract type.\n（エラーコード：FE-CU10-E0009）',
    },
    FECU12警報確認画面: {
      C0001:
        'You can check the alarm status of the target area.\nThe color of the icon indicates the following:\nRed: Alarm in progress\nWhite: Normal condition\nYou can check the status of each sensor installed by pressing each alarm icon.\nTo deactivate the intruder alarm, a security operation by the user is required.',
    },
    FECU13戸締り確認画面: {
      C0001:
        'You can check the lock-up status for each target area.\nThe color of the icon indicates the following:\nRed: Lock-up abnormality\nWhite: Normal condition\nGray: Failed to acquire the lock-up status\nPress each area to check the status of each opening-closing sensor installed.',
    },
    FECU14警報確認画面センサー: {
      C0001:
        'The status of the alarm device in the target area is displayed. If a sensor detects an abnormality, you can check the status of each sensor.\nFor the customer who has a contract for Self security, check the status on this screen, and request ALSOK to rush to the area if necessary.(You can check the contact information on the Request Emergency Assistance screen.)',
    },
    FECU15戸締り確認画面エリア: {
      C0001:
        'You can check the status of security sensors installed in the target area.\nThe lock-up abnormality status can be restored to the normal status by the following procedure.\n- Close the door equipped with the opening-closing sensor\n- Move away from the sensing area of the spatial sensor',
    },
    FECU16かけつけ依頼画面: {
      C0001:
        'You can request the Emergency Assistance on Demand (for a fee) by phone.\nPlease check the precautions displayed on the screen before making a phone call.\nWhen you use a smartphone, press the phone number to start the phone application.\nWhen you use a PC, call the phone number displayed on the screen.',
    },
    FECU17通知履歴画面: {
      C0001:
        'You can view the last 31 days’ notifications.\nFor notifications of the home security and camera, you can narrow down the notifications to be displayed by target area, camera, alarm type, etc.',
    },
    FECU18ALSOKへのお問い合わせ画面: {
      C0001:
        'The following is the phone number for inquiries.\nPlease check the precautions displayed on the screen before making a phone call.\nWhen you use a smartphone, press the phone number to start the phone application.\nWhen you use a PC, call the phone number displayed on the screen.',
    },
    FECU19対象地区設定画面: {
      C0001: 'You can check or change various settings for target areas.',
    },
    FECU20ニックネーム設定画面: {
      C0001: 'The content you entered will be registered.\nOK?',
      C0002:
        'You can change the nicknames of target areas.\nNicknames are displayed in the list of target areas, batch user security operations, etc.\nThe list of target areas is sorted in ascending order by nickname when displayed. If you want to change the display order, change the nickname.\nNicknames are for your use only; please use "official area name" when contacting ALSOK.',
      C0003: 'Nickname registration is completed.',
      E0001: 'Be sure to enter a nickname.',
      E0002: 'Enter a nickname in half-width or full-width characters.',
      E0004: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU20-E0004)',
    },
    FECU21IDカードキー情報設定画面: {
      C0001:
        'You can change the nickname of an ID card/key and enable/disable it.\nThe nickname is displayed on the Notification History screen when a security operation is performed by using the ID card/key.',
      C0002: 'The content you entered will be set.\nOK?',
      C0004: 'The setup is not complete. \nDo you want to move to the next screen?',
      E0001: 'Be sure to enter a nickname.',
      E0002: 'Enter a nickname in half-width or full-width characters(JIS X 0208 or equivalent).',
      E0004: 'Setup failed.\nPlease perform the setup again.\n(Error Code: FE-CU21-E0004)',
      E0006:
        'Failed to acquire card information.\nRefresh the screen again.\n(Error Code: FE-CU21-E0006)',
    },
    FECU22通知配信設定画面: {
      C0001:
        'You can set up PUSH/email notifications for target areas.\nIf you want to receive only specific notifications, select Send notifications, and select the checkbox(es) of only the notification(s) that you want to receive.\nIf you select Do not send notifications, PUSH and email notifications will not be sent to your email address, but you can check the contents of notifications on the Notification History screen.',
      C0002: 'The content you entered will be registered.\nOK?',
      E0001: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU22-E0001)',
      E0002: 'Select one or more checkboxes of push notifications.',
      E0003: 'Select one or more checkboxes of email notifications.',
    },
    FECU23見守り情報配信設定画面: {
      C0001:
        'For the Monitoring Information Delivery Service, you can set the monitoring method.\nThere are three types of monitoring methods, which can be selected according to the customer’s situation.\nAccording to the selected monitoring method, you can also set the monitoring time and the email delivery time.\n- Regular communication: When you want to receive information about normal status and the occurrence of an abnormality by email/PUSH notification at constant time interval\n- Abnormality notification: When you want to receive information about the occurrence of an abnormality by email/PUSH notification if a sensor does not start operating within the specified time period\n- Scheduled communication: In addition to abnormality notifications, when you want to receive information about the normal status and the occurrence of an abnormality by email/PUSH notification at the specified time\n* Startup operation omission notification: You can receive an email/PUSH notification if the monitoring start operation has not been performed.',
      C0002:
        'The content you entered will be set. Customer number: This number will be reflected in all target areas of {0}.\nOK?',
      C0003: 'Monitoring information delivery setting is completed.',
      C0004: 'The content you entered will be reflected in all target areas.\nOK?',
      E0001: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU23-E0001)',
      E0002: 'Be sure to enter the regular communication time.',
      E0003: 'Enter a regular communication time in half-width numerals.',
      E0004: 'Enter a regular communication time between 5 and 900 minutes.',
      E0005: 'Be sure to enter the scheduled communication time (1).',
      E0006: 'Enter a time for scheduled communication time (1).',
      E0007:
        'For scheduled communication time (1), you cannot enter the same time as scheduled communication time (2) and (3).',
      E0008: 'Enter a time for scheduled communication time (2).',
      E0009:
        'For scheduled communication time (2), you cannot enter the same time as scheduled communication time (1) and (3).',
      E0010: 'Enter a time for scheduled communication time (3).',
      E0011:
        'For scheduled communication time (3), you cannot enter the same time as scheduled communication time (1) and (2).',
      E0012: 'Be sure to enter the operation omission monitoring timer.',
      E0013: 'Be sure to enter the operation omission monitoring timer in half-width numerals.',
      E0014: 'Be sure to enter an operation omission monitoring timer between 1 and 99 hours.',
      E0015: 'Be sure to enter the delivery time (From).',
      E0016: 'Be sure to enter the delivery time (From) in half-width numerals.',
      E0018: 'Be sure to enter the delivery time (To).',
      E0019: 'Be sure to enter the delivery time (To) in half-width numerals.',
      E0025: 'Be sure to enter the abnormality notification time',
      E0026: 'Enter a abnormality notification time in half-width numerals.',
      E0027: 'Enter a abnormality notification time between 5 and 900 minutes.',
      E0028: 'Be sure to enter scheduled communication time',
      E0029: 'Be sure to enter the scheduled communication time in half-width numerals.',
      E0030: 'Enter a regular communication time between 5 and 900 minutes.',
      E0031: 'Be sure to enter at least one scheduled communication time.',
    },
    FECU24機器制御画面: {
      C0001:
        'You can remote-control the buzzers and lights of devices installed.\nBuzzers and lights activated by a sensor that detects an abnormality cannot be stopped on this screen.',
      C0002: 'The content you entered will be registered.\nOK?',
      E0001: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU24-E0001)',
      E0002: 'Failed to load.\nRefresh the screen again.\n(Error Code: FE-CU24-E0002)',
    },
    FECU25カメラ画面: {
      C0001:
        'A list of cameras registered to the current user is being displayed.\nIcons displayed for each camera indicate the functions the user can use for the camera.\nYou can check the details by pressing each camera.\n\nThe Notification History (within 24 hours) tab displays notifications for the listed cameras.',
    },
    FECU26カメラ詳細画面: {
      C0001:
        'The current status of cameras and the current status of the areas where the cameras are installed are displayed.\nYou can check details by pressing each button.\n- Camera Image button\n　When you press this button, the camera application starts and you can check the current images.\n- Request Emergency Assistance button\n　You can request ALSOK to rush to the target area (for a fee).\n- Notification History button\n　You can check the history of notifications sent to your email address.\n- Inquiry for ALSOK\n　You can check the contact information for inquiries.\n- Set Cameras button\n　Opens the setting screen for cameras. (For detailed settings of the camera body, please check the settings via the camera application.)\n\nThe Notification History (within 24 hours) tab displays notifications for cameras. (This tab is not displayed if you do not have authority for Notification/Notification History.)',
    },
    FECU27カメラ設定画面: {
      C0001: 'You can check or change various settings for cameras.',
    },
    FECU28ニックネーム設定画面カメラ: {
      C0001:
        'You can change the nicknames of cameras.\nThe nicknames are displayed in the camera list, Notification History, etc.\nThe list of cameras is sorted in ascending order by nickname when displayed. If you want to change the display order, change the nickname.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0003: 'Nickname registration is completed.',
      E0001: 'Be sure to enter a nickname.',
      E0003: 'Enter a nickname in half-width or full-width characters.',
      E0004: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU28-E0004)',
    },
    FECU29通知配信設定画面カメラ: {
      C0001:
        'You can set up PUSH and email notifications for cameras.\nIf you want to receive only specific notifications, select Send notifications, and select the checkbox(es) of only the notification(s) that you want to receive.\nIf you select Do not send notifications, PUSH and email notifications will not be sent to your email address, but you can check the contents of notifications on the Notification History screen.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0003: 'Notification delivery setting is completed.',
      E0001: 'Registration failed.\nPlease register again.\n(Error Code: FE-CU29-E0001)',
      E0002: 'Select one or more checkboxes of push notifications.',
      E0003: 'Select one or more checkboxes of email notifications.',
    },
    FECU30ハウスサポート等お問い合わせ画面: {
      C0001:
        'The phone numbers and links to web pages are displayed for inquiries such as health consultations.\nWhen you use a smartphone, press the phone number to start the phone application.\nPlease check the precautions displayed on the screen before making a phone call.',
      E0001:
        'Failed to start the application.\nPress the phone number buttons again.\n(Error Code: FE-CU30-E0001)',
    },
    FECU31各種設定画面: {
      C0001:
        'For the account management (target area), account management (camera), account management (user information), and login method (*1), you can select the setting item and configure settings on each screen.\n*1: The login method can be set only for the smartphone application.',
      C0002:
        'Account management (target area) is displayed in the web browser.\nAt this time, you will be logged out of the application.\nDo you want to display the account management (target area)?',
      C0003:
        'Account management (camera) is displayed in the web browser.\nAt this time, you will be logged out of the application.\nDo you want to display the account management (camera)?',
      C0004:
        'Account management (user information) is displayed in the web browser.\nAt this time, you will be logged out of the application.\nDo you want to display the account management (user information)?',
    },
    FECU32アカウント管理対象地区画面: {
      C0001:
        'A list of target areas registered to the current user is displayed.\nYou can perform the following operations by pressing the items displayed for each target area.\nUser management: Change registered sub-users.\nEmergency contact: Change the emergency contact information registered for the destination for security.',
    },
    FECU33アカウント管理カメラ画面: {
      C0001:
        'A list of cameras registered to the current user is displayed.\nYou can perform the following operations by pressing the items displayed for each target area.\nUser management: Change registered sub-users.\nEmergency contact: Change the emergency contact information registered for the destination for security.',
      C0002: 'Delete the displayed camera.\nOK?',
      C0003: 'Deletion is completed.',
      E0001: 'Failed to delete.\nPerform the deletion again.\n(Error Code: FE-CU33-E0001)',
    },
    FECU34アカウント管理ユーザー情報画面: {
      C0001:
        'Your account information is displayed. You can change the settings for each item by pressing the "Change" button.',
    },
    FECU35ログイン方法設定画面: {
      C0001:
        'You can change the login method.\nBiometric authentication may not be available depending on your smartphone.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0003: 'Setup is completed.',
      C0004: 'The setup is not complete.\nDo you want to move to the next screen?',
    },
    FECU36パスコード設定画面: {
      C0001:
        "You can set or change the application's passcode.\nThe passcode that you set will be used when you log in, so please store it carefully.",
      C0002:
        'Passcode setting is completed.\nNo biometric information is registered.\nDo you want to open the setting and set up biometrics?',
      C0003: 'Passcode setting is completed.',
      E0001: 'Enter the passcode only in half-width numerals.',
      E0002: 'The confirmation passcode does not match.\nPlease enter it again from the beginning.',
      E0003: 'Setup failed.\nPlease enter it again.\n(Error Code: FE-CU36-E0003)',
    },
    FECU37ユーザー管理画面: {
      C0001:
        'A list of users registered for the displayed target area or camera is displayed.\nYou can configure or change settings on each screen by pressing the "Change" button.\nThe "Add Sub-users" button allows you to add a new sub-user.\nThe "Transfer Main User" button allows you to transfer the main user authority to a registered sub-user.\nThe "Transfer Main User" button can be selected if the current user is the main user of the target area or camera.',
    },
    FECU38サブユーザー権限変更画面: {
      C0001:
        'You can change the authorities of sub-users.\nWhen you press the "Recommended" button, the authority settings recommended by ALSOK are displayed.\nIf you select the checkbox of "Exclude from the target area" or "Exclude from the camera", the target user will be excluded from the target area or camera.\nWhen excluded, if the number of areas/cameras registered to the user becomes 0, the user will be deleted.\nPlease check the manual for what each operation authorities can do.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0003:
        'Delete user information because there are no target areas/cameras associated with this user.\nOK?',
      E0001: 'Setup failed.\nPlease perform the setup again.。\n(Error Code: FE-CU38-E0001)',
    },
    FECU39新規サブユーザー登録画面仮登録: {
      C0001:
        'You can temporarily register a new sub-user.\nWhen you press the "Recommended" button, the authority settings recommended by ALSOK are displayed.\nEmail containing a one-time URL will be sent to the email address you entered. Please access the one-time URL and perform the procedure.\nPlease check the manual for what each operation authorities can do.',
      C0002: 'Provisional registration will be performed with the information you entered.\nOK?',
      E0001: 'The email address you entered is already registered.\n(Error Code: FE-CU39-E0001)',
      E0002:
        'Provisional registration failed.\nPlease register again.\n(Error Code: FE-CU39-E0002)',
      E0003: 'The format of the email address is incorrect.',
      E0004: 'The format of the confirmation email address is incorrect.',
      C0005: 'Registration is completed.',
      E0005: 'Be sure to enter your email address.',
      E0006: 'Be sure to enter your confirmation email address.',
      E0007: 'The email address does not match the confirmation email address.',
    },
    FECU40メインユーザー移譲画面: {
      C0001:
        'You can transfer the main user to the specified sub-user.\nAfter the sub-user is approved, the transfer is completed.\nAfter the transfer is completed, the current user will be changed to a sub-user.',
      C0002: 'Transfer the main user.\nOK?',
      C0003: 'Enter your password.',
      E0001: 'Be sure to enter your password.',
      E0004: 'For the password, enter 20 characters or less.',
      E0005:
        'The password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      C0004: 'A transfer request was sent.',
      E0006:
        'Main user transfer processing failed.\nPlease try again.\n(Error Code: FE-CU40-E0006)',
    },
    FECU41承認可否選択画面: {
      C0001:
        'Check the contents displayed on the screen, and select "Approve" or "Reject".\nIf you approve them, the change will be reflected, and if you reject them, the change will be canceled.',
      C0002: 'Approve the changes.\nOK?',
      C0003: 'Reject the changes.\nOK?',
      C0004: 'The changes have been approved.',
      C0005: 'The changes have been rejected.\nThe content of the changes has been cancelled.',
      C0006: 'Approve the sub-user registration.\nOK?',
      C0007: 'Reject the sub-user registration.\nOK?',
      C0008: 'The sub-user registration has been approved.',
      C0009: 'The sub-user registration has been rejected.\nRegistration has been cancelled.',
      C0010: 'Approve changes to the user information.\nOK?',
      C0011: 'Reject changes to the user information.\nOK?',
      C0012: 'The changes to the user information have been approved.',
      C0013:
        'The changes to the user information have been rejected.\nThe changes have been cancelled.',
      E0001: 'Transfer of the main user failed.\nPlease try again.\n(Error Code: FE-CU41-E0001)',
      E0002: 'Failed to register the sub-user.\nPlease try again.\n(Error Code: FE-CU41-E0002)',
      E0003: 'Failed to change the user information.\nPlease try again.',
    },
    FECU42緊急連絡先設定画面: {
      C0001:
        'You can register emergency contact information, information on family members living with you, and first aid information.\nThe number of emergency contacts cannot be 0. Up to five entries can be registered.\nFor information on family members living with you, up to seven members can be registered.\nThe secret code is used for identification when a family member living with you contacts ALSOK.\nFirst aid information can be registered only by the person who has a contract. Up to two entries can be registered.\nFor first aid information, register information such as a chronic disease or a family hospital in advance, and the information will be passed to an ambulance crew in case emergency transport is required.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0003: 'Delete the emergency contact displayed.\nOK?',
      C0004: 'Registration is completed.',
      C0005: 'Deletion is completed.',
      C0006: 'The order has been applied.',
      C0007: 'The order has not been applied.\nDo you want to move to the next screen?',
      C0008: 'Change is completed.',
      E0001: 'Be sure to enter your full name.',
      E0003: 'Be sure to enter your full name (kana).',
      E0005: 'Please enter your full name (kana) in full-width katakana characters.',
      E0006: 'Be sure to enter relationships.',
      E0008: 'Be sure to enter the phone number.',
      E0010: 'Enter the phone number in half-width numerals and “- (hyphen)”.',
      E0011: 'Failed to change.\nPlease change it again.\n(Error Code: FE-CU42-E0011)',
      E0012: 'Failed to add.\nPlease add it again.\n(Error Code: FE-CU42-E0012)',
      E0013: 'Failed to delete.\nPlease delete it again.\n(Error Code: FE-CU42-E0013)',
      E0014:
        'Failed to acquire emergency contact information. Refresh the screen again.\n(Error Code: FE-CU42-E0014)',
      E0015: 'No emergency contact information is registered.\n(Error Code: FE-CU42-E0015)',
      E0016: 'Sorting failed.\nPlease perform the operation again.\n(Error Code: FE-CU42-E0016)',
    },
    FECU43緊急連絡先設定画面同居家族情報: {
      C0003: 'Delete the family members’ information displayed.\nOK?',
      E0004: 'Enter the secret code (furigana) in full-width katakana characters.',
      E0006: 'Be sure to enter your full name.',
      E0008: 'Be sure to enter your full name (kana).',
      E0010: 'Please enter your full name (kana) in full-width katakana characters.',
      E0011: 'Be sure to select the relationship.',
      E0012: 'Be sure to enter the relationship.',
      E0014: 'Be sure to enter the date of birth.',
      E0015: 'Failed to change.\nPlease change it again.\n(Error Code: FE-CU43-E0015)',
      E0016: 'Failed to add.\nPlease add it again.\n(Error Code: FE-CU43-E0016)',
      E0017: 'Failed to delete.\nPlease delete it again.\n(Error Code: FE-CU43-E0017)',
      E0018: 'Enter both secret code and secret code (furigana) or leave both blank.',
      E0019: 'No family members are registered.\n(Error Code: FE-CU43-E0019)',
      E0020:
        'Failed to acquire the information of the family members living together.\n(Error Code: FE-CU43-E0020)',
      E0021: 'Sorting failed.\nPlease perform the operation again.\n(Error Code: FE-CU43-E0021)',
    },
    FECU44緊急連絡先設定画面救急情報: {
      C0002: 'Delete the first aid information displayed.\nOK?',
      E0001: 'Failed to delete.\nPlease perform the operation again.\n(Error Code: FE-CU44-E0001)',
      E0002: 'Failed to acquire first aid information.\n(Error Code: FE-CU44-E0002)',
    },
    FECU45救急情報設定画面: {
      C0001:
        'Please register the first aid information.\nWhen a security guard arrives, if you have to be rushed to a hospital by ambulance, the information you registered will be passed to a paramedic.',
      E0001: 'Be sure to enter your full name.',
      E0003: 'Be sure to enter your full name (kana).',
      E0005: 'Please enter your full name (kana) in full-width katakana characters.',
      E0006: 'Be sure to enter your gender.',
      E0007: 'Be sure to enter the date of birth.',
      E0008: 'Enter the date of birth in half-width numeric symbols.',
      E0010: 'Invalid input.',
      E0011: 'Be sure to enter your previous disease (disease name).',
      E0013: 'Be sure to enter the name (name of the medical institution).',
      E0015: 'Be sure to enter the address.',
      E0017: 'Be sure to enter the phone number.',
      E0018: 'Enter the phone number in half-width numerals and “- (hyphen)”.',
      E0020: 'Be sure to enter the doctor in charge.',
      E0022: 'Setup failed.\nPlease perform the setup again.\n(Error Code: FE-CU45-E0022)',
      E0028:
        'The content has been updated.\nPlease perform the setup again.\n(Error Code: FE-CU45-E0028)',
    },
    FECU46サービス追加画面: {
      C0001:
        'Add services used in the application or website.\nIf you want to add home security, enter the "customer number" and "authentication number" provided by ALSOK.\nTo add a camera, check "Device ID" via the camera application and enter it.\nTo register a camera attached to a service such as the Self security or Online security, enter the "customer number" and "authentication number" when registering the camera.\nTo add other services, please check the services you want to add.',
      C0002: 'The content you entered will be registered.\nOK?',
      C0004: 'Select the area where a camera will be installed.',
      C0005: 'Open HomeLink’s authentication screen (another site).',
      C0006: 'Registration is completed.',
      E0001: 'Be sure to enter the customer number.',
      E0002: 'Enter the customer number in half-width numerals.',
      E0004: 'Be sure to enter the serial number.',
      E0005: 'Enter the serial number in half-width English numerals.',
      E0007: 'Be sure to enter the authentication number.',
      E0009: 'Be sure to enter the device ID.',
      E0011: 'Enter the device ID in half-width English numerals.',
      E0012:
        'For the service you are trying to register, a main user is already registered.\n(Error Code: FE-CU46-E0012)',
      E0013:
        'Failed to add the service. Please check the content you entered and then register it again.\n(Error Code: FE-CU46-E0013)',
      E0015: 'Enter the authentication number in half-width numerals.',
      E0016:
        'The customer number, or authentication number is incorrect.\nPlease check the content you entered and then register it again.\n(Error Code: FE-CU46-E0016)',
      E0017:
        'Failed to add the service.\nPlease check the content of your HomeLink registration.\n(Error Code: FE-CU46-E0017)',
      E0018:
        'The customer number or authentication number is incorrect.\nPlease check the content you entered and then register it again.\n(Error Code: FE-CU46-E0018)',
      E0019:
        'Authentication failed.\nPlease check the content of your HomeLink registration.\n(Error Code: FE-CU46-E0019)',
    },
    FECU47ユーザー情報変更画面氏名電話番号: {
      C0001: 'The current user can set or change their name, gender, and birth year.',
      C0002: 'The current content will be changed with the content you entered.\nOK?',
      E0001: 'Be sure to enter your full name.',
      E0006:
        'Failed to change the user information (name).\nPlease perform the setup again.\n(Error Code: FE-CU47-E0006)',
    },
    FECU48ユーザー情報変更画面メールアドレス: {
      C0001:
        'The current user can change their user ID (email address).\nEmail containing a one-time URL will be sent to the email address that you newly set. Please access the one-time URL and perform the procedure.',
      C0002: 'The current content will be changed with the content you entered.\nOK?',
      E0001: 'Be sure to enter your user ID (email address).',
      E0002: 'Be sure to enter the confirmation user ID (email address).',
      E0003: 'The user ID (email address) does not match the confirmation user ID (email address).',
      E0004: 'Be sure to enter your password.',
      E0005: 'The password you entered is incorrect.\n(Error Code: FE-CU48-E0005)',
      E0006: 'The format of the user ID (email address) is incorrect.',
      E0007: 'The format of the confirmation user ID (email address) is incorrect.',
      E0012:
        'Failed to change the user information (email address).\nPlease perform the setup again.\n(Error Code: FE-CU48-E0012)',
    },
    FECU49ユーザー情報変更画面パスワード: {
      C0001:
        'The current user can change their login password.\nRegister a password that is difficult to guess.',
      C0002: 'Change the password.\nOK?',
      E0001: 'Be sure to enter the current password.',
      E0002: 'Be sure to enter the password you changed.',
      E0003: 'Be sure to enter a confirmation password.',
      E0004: 'The changed password does not match the confirmation password.',
      E0005: 'The password you entered is incorrect.\n(Error Code: FE-CU49-E0005)',
      E0009:
        'The new password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0011:
        'The confirmation password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0012:
        'Failed to change the user information (password).\nPlease perform the setup again.\n(Error Code: FE-CU49-E0012)',
      E0013: 'For the password, enter eight characters or more.',
    },
    FECU50ユーザー情報変更秘密の質問: {
      C0001:
        'The current user can change their secret question/answer.\nPlease keep the secret question/answer safely because you will need them when initializing the password.',
      C0002: 'Change your secret question.\nOK?',
      C0003: 'Enter your password.',
      E0003: 'Be sure to enter your answer.',
      E0005: 'The password you entered is incorrect.\n(Error Code: FE-CU50-E0005)',
      E0006: 'Be sure to enter your secret question.',
      E0010: 'Please enter your answer in hiragana.',
      E0011:
        'Failed to change the user information (secret question).\nPlease perform the setup again.\n(Error Code: FE-CU50-E0011)',
    },
    FECU51アカウント削除画面: {
      C0001:
        'Delete the current user’s account.\nIf sub-users are registered for the area or camera where the current user is the main user, the account cannot be deleted.\nTransfer the main user authority to a sub-user or exclude all sub-users from the area/camera before deleting the account.',
      C0002:
        'You are the main user of the following Home Security or Camera.\nDo you want to delete the account?',
      E0001: 'Be sure to enter your password.',
      E0003: 'The password you entered is incorrect.\n(Error Code: FE-CU51-E0003)',
      E0004:
        'The main user cannot be deleted because sub-users are associated with the main user.\n(Error Code: FE-CU51-E0004)',
    },
    FECU52新規メインユーザー登録画面仮登録: {
      C0001:
        'Perform the provisional registration of a new user.\nIf you want to register for home security, enter the "customer number" and "authentication number" provided by ALSOK.\nIf you want to register for a camera, check "Device ID" via the camera application and enter it.\nTo register a camera attached to a service such as the Self security or Online security, enter the "customer number" and "authentication number" when registering the camera.\nAfter the provisional registration is completed, email containing a one-time URL will be sent to the email address you entered, so please perform the registration formally from that URL.',
      C0002: 'Provisional registration will be performed with the information you entered.\nOK?',
      C0004: 'Select the area where a camera will be installed.',
      E0001: 'Be sure to enter the customer number.',
      E0003: 'Enter the customer number in half-width numerals.',
      E0004: 'Be sure to enter the serial number.',
      E0006: 'Enter the serial number in half-width English numerals.',
      E0007: 'Be sure to enter the authentication number.',
      E0008: 'Be sure to enter your user ID (email address).',
      E0009: 'Be sure to enter the confirmation user ID (email address).',
      E0010: 'The user ID (email address) does not match the confirmation user ID (email address).',
      E0012: 'Be sure to enter the device ID.',
      E0014: 'Enter the device ID in half-width English numerals.',
      E0015: 'The customer number you entered is already registered for the main user.',
      E0016:
        'Failed to add the service.\nPlease check the content you entered and then register it again.\n(Error Code: FE-CU52-E0016)',
      E0018: 'Enter the authentication number in half-width numerals.',
      E0019: 'The format of the user ID (email address) is incorrect.',
      E0020: 'The format of the confirmation user ID (email address) is incorrect.',
      E0021:
        'The customer number, authentication number or email address is incorrect.\nPlease check the content you entered and then register it again.\nIf you are already using the service, please add the service after log in.\n（Error Code: FE-CU52-E0021）',
      E0022:
        'Failed to add the service.\nPlease check the content of your HomeLink registration.\n(Error Code: FE-CU52-E0022)',
      E0023:
        'The customer number, authentication number or email address is incorrect.\nPlease check the content you entered and then register it again.\nIf you are already using the service, please add the service after log in.\n（Error Code: FE-CU52-E0023）',
      E0024:
        'The service you are trying to register is already registered for the main user.\n(Error Code: FE-CU52-E0024)',
      E0025:
        'Authentication failed.\nPlease check the contents of your HomeLink registration.\n(Error Code: FE-CU52-E0025)',
    },
    FECU53ユーザー登録画面本登録: {
      C0001:
        'Register the user formally.\nPlease keep the answer to the secret question safely because you will need it when initializing the password.\nSet a password that is difficult to guess.',
      E0001: 'Be sure to enter your full name.',
      E0003: 'Be sure to enter your password.',
      E0004: 'Be sure to enter a confirmation password.',
      E0005: 'The password does not match the confirmation password.',
      E0006: 'Be sure to enter your secret question.',
      E0008: 'Be sure to enter your answer.',
      E0012:
        'The registration process failed.\nPerform the registration again.\n(Error Code: FE-CU53-E0012)',
      E0014:
        'The password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0016:
        'The confirmation password must contain at least three types of the following: half-width uppercase Roman characters, half-width lowercase Roman characters, numerals, and symbols.',
      E0017: 'Please enter your answer in hiragana.',
      E0019: 'For the password, enter eight characters or more.',
      E0020: 'For the confirmation password, enter eight characters or more.',
      E0023: 'This user is already registered.\n(Error Code: FE-CU53-E0023)',
    },
    FECU54Thanks画面: {
      E0001:
        'Failed to start the application.\nPress "Please contact the ALSOK office in charge." again.\n(Error Code: FE-CU54-E0001)',
    },
    FECU56利用規約画面: {
      C0001: 'The following are the Terms of Use for this service.',
    },
    FECU57プライバシーポリシー画面: {
      C0001: 'The following is the Privacy Policy for this service.',
    },
    FECU58利用規約プライバシーポリシー同意画面: {
      C0001:
        'Please read the Terms of Use and Privacy Policy of this service, and select the checkbox of "I agree" if you agree to the Terms.',
    },
    FECU59ライセンス: {
      C0001: 'The following is the License Information for this service.',
    },
  },
  // ------------------------ 以下画面単位 -------------------------------------
  // FE-CU1 path: "/login",
  FECU01ログイン画面: {
    お客様Webサイト: 'HOMEALSOK',
    お客様アプリ: 'Customer app',
    ユーザーIDを記憶する: 'Memorize the user ID',
    ログイン: 'Login',
    新規メインユーザー登録: 'New main user registration',
    パスワードを忘れた場合: 'Forgot your password?',
    ユーザーID: 'User ID (email address)',
    パスワード: 'Password',
    パスコードでログイン: 'Log in with passcode',
    キャンセルボタン: 'Cancel',
    生体認証ボタン: 'Biometric',
    エラー: 'Error',
    ログインに失敗しました: 'Failed to log in.',
    OKボタン: 'OK',
    認証に失敗しました: {
      生体認証:
        'Authentication failed.\nBiometric and passcode authentication will not be available for a certain period of time.',
      パスコード:
        'Authentication failed.\nPasscode authentication will not be available for a certain period of time.',
    },
    ALSOKからのお知らせ: 'Message from ALSOK',
    お知らせはありません: 'No announcements',
    お知らせ日付: '{0}/{1}/{2} {3}:{4}', // 数字は呼び出す際に付与する引数のindex
    健康相談等: 'Health consultation, etc.',
    パスコードまたは生体認証でログイン: 'Login with passcode or biometric authentication',
  },
  // FE-CU2
  FECU02トップ画面: {
    トップ: 'Top',
    通知履歴: 'Notification history',
    設定: 'Setting',
    日本語: 'Japanese',
    English: 'English',
    ユーザーマニュアル: 'User Manual',
    通販ショップ: 'Mail-order shop',
    利用規約: 'Terms of Use',
    プライバシーポリシー: 'Privacy Policy',
    ライセンス情報: 'License information',
    ログアウト: 'Logout',
    ヘルプ: 'Help',
    お知らせ: 'Announcement',
    閉じるボタン: 'Close',
    確認警告: 'Check/Warning',
    いいえボタン: 'No',
    はい: 'Yes',
    全て選択ボタン: 'Select All',
    クリアボタン: 'Clear',
    システムエラーが発生しました: {
      エラーコード有:
        'A system error has occurred.\n(Error Code: {0})\nPlease contact ALSOK Sales.', //{0}はエラーコード,
      エラーコード無: 'A system error has occurred.\nPlease contact ALSOK Sales.',
    },
    通信に失敗しました: 'Failed to communicate.\nPlease wait for a while and try again.',
    警備ユニットとサーバー間の通信に失敗しました:
      'Communication between the security unit and the server failed.\nPlease contact the ALSOK office in charge.',
    ダイアログメッセージ:
      'The PUSH notification setting on your smartphone or tablet is disabled.\nCheck the settings of your smartphone/tablet.',
    設定画面を開くボタン: 'Open Settings',
    このまま使用するボタン: 'Use As It Is',
    内容が更新されました: 'The content has been updated.\nRefresh the screen again.',
    カメラ: 'Camera',
    ホームセキュリティ: 'Home Security',
    ホームセキュリティモバイル: 'Home\nSecurity',
    //以下文言は設計書FE-CU02未記載だが、表示に必要なため追加
    対象地区選択: 'Select the Target Area',
    一括警備操作: 'Batch security operation (target area selection)',
    新規メイン: 'New main',
    ユーザー登録: 'User registration',
    ライセンス: 'License',
    プライバシー: 'Privacy',
    開く: 'Open',
    閉じる: 'Close',
  },
  // FE-CU03_2段階認証画面 path: "/twoStepAuthentication",pages/user/oneTimePassword/Index.vue"
  FECU03二段階認証画面: {
    二段階認証: 'Two-step authentication',
    // ご登録いただいているメールアドレスに:
    //   "ご登録いただいているメールアドレスに「{0}」メールを送信しました。{1}分以内にメール本文に記載されている認証コードを入力し、認証を完了させてください。", //{0}「●●（件名）」,{1}●分,
    ご登録いただいているメールアドレスに:
      'Email with "{0} (Subject)" has been sent to the registered email address.',
    認証を完了させてください:
      'Enter the authentication code described in the email text within {0} minutes to complete the authentication.',
    ご利用の端末から:
      'When you log in from your terminal for the first time, two-step authentication is required.', //設計書赤文字
    メールが届かない場合は以下の可能性が考えられます:
      'If you have not received an email, one of the following reasons may be the cause.\nAfter changing the email settings, use the "<" or "Back" button to go to the Login screen and log in again.',
    迷惑メールとして処理されている可能性があります:
      'It may have been handled as spam.\nPlease check if there is any email with the subject "{0}" in the spam mail folder, trash box, etc.', //{0}（件名）
    ドメイン指定を行っている方は:
      'If you have specified a domain, set it so that "{0}" can be received.', //{0}ドメイン名
    認証ボタン: 'Authentication',
    戻るボタン: 'Back',
    認証コード: 'Authentication code',
  },
  // FE-CU04_パスワード初期化画面（ユーザーID入力） path: "/passwordInitUserIdEntry",pages/passwordInitUserIdEntry/Index.vue
  FECU04パスワード初期化画面ユーザーID入力: {
    パスワード初期化ユーザーID: 'Password re-registration (user ID)',
    ユーザーIDメールアドレス: 'User ID (email address)',
    確認用: 'For confirmation',
    メールを送信ボタン: 'Send Email',
    戻るボタン: 'Back',
  },
  // FE-CU05_パスワード初期化画面（秘密の質問） path: "/passwordInitSecretQuestion",pages/passwordInitSecretQuestion/Index.vue
  FECU05パスワード初期化画面秘密の質問: {
    秘密の質問: 'Secret question',
    回答ひらがな: 'Answer (hiragana)',
    次へボタン: 'Next',
    回答が誤っています: 'The answer is incorrect.',
    OKボタン: 'OK',
    閉じるボタン: 'Close',
    確認: 'Confirm',
  },
  // FE-CU06_パスワード初期化画面（パスワード再登録） path: "/passwordInitReregistration",pages/passwordInitReregistration/Index.vue
  FECU06パスワード初期化画面パスワード再登録: {
    パスワード再登録: 'Password re-registration',
    新しいパスワード: 'New password',
    確認用: 'For confirmation',
    再登録ボタン: 'Re-register',
  },
  // FE-CU7
  FECU07: {
    トップ: 'Top',
    ホームセキュリティ: 'Home',
    セキュリティ: 'Security',
    カメラ: 'Camera',
    サービス追加: 'Add a Service',
    警備操作: 'Security operation',
    対象地区: 'Target area',
    対象地区選択ボタン: 'Target Area',
    外出: 'Away',
    在宅: 'Home',
    解除: 'Deactivate',
    オンライン: 'ALSOK',
    警備: 'ALSOK security away mode',
    セルフ: 'Self',
    設定ボタン: 'Setting',
    ホーム: 'Home',
    ALSOKからのお知らせ: 'Message from ALSOK',
    お知らせ日付: '{0}/{1}/{2} {3}:{4}', // 数字は呼び出す際に付与する引数のindex
    一括警備操作: 'Batch security operation \n(target area selection)',
    全て選択ボタン: 'Select All',
    クリアボタン: 'Clear',
    キャンセルボタン: 'Cancel',
    適用ボタン: 'Apply',
    警報を解除しました: 'Security was deactivated in {0} of {1} areas.',
    対象地区名: 'Target areas: {0}', //●●● no60,63,64で使用
    OKボタン: 'OK',
    警備操作が完了しました: 'Security has been started in {0} of {1} areas.',
    警備操作が失敗した地区があります:
      'Security could not be started in some areas due to the following problem.',
    発生しました: '{0} has occurred',
    戸締まり状態が異常です: 'The lock-up status is abnormal.\nPlease check the lock-up.',
    警備します: 'E警備します。\nよろしいでしょうか。',
    在宅対象確認ボタン: 'Check Subarea',
    在宅対象エリア: 'Subarea - {0}', //
    警備状態表示: {
      外出ALSOK警備中: 'ALSOK security away mode',
      在宅ALSOK警備中: 'ALSOK security home mode',
      外出セルフ警備中: 'self security away mode',
      在宅セルフ警備中: 'self security home mode',
      警備解除中: 'Security deactivated mode',
      ユーザ点検: 'User checking mode',
    },
    一括警備操作を適用します: 'Apply the area subject to the batch security operation.\nOK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    // 設計書にはないが必要だったため追加
    健康相談等: 'Health consultation, etc.',
    アップ: 'Useful Information',
    グレード: '',
    確認: 'Confirm',
    入力された内容で登録します: 'The content you entered will be registered.\nOK?',
    警備状態を変更: 'Change Security Status',
    お知らせ: 'Announcement',
    複数選択中: 'Multiple selections',
    読点: ', ',
    // PUSH通知確認ダイアログ
    設定をご確認ください:
      'The PUSH notification setting on your smartphone or tablet is disabled.\nCheck the settings of your smartphone/tablet.',
    設定画面を開く: 'Open Settings',
    このまま使用する: 'Use As It Is',
    選択できません: '"ALSOK" cannot be select.',
    一括警備操作ダイアログ: {
      警備状態を変更できません:
        'For the specified areas in the following, the security status could not be changed.\nAfter changing to the deactivated status, perform a security operation or check your contract type.\n　・Target areas: {0}\n（Error Code：FE-CU7-C0015）\n',
      警備状態を変更できません_解除:
        'For the specified areas in the following, the security status could not be changed.\nThe security status may have already been deactivated.Check the security status.\n　・Target areas: {0}\n（Error Code：FE-CU7-C0016）\n',
      警備ユニットエラー:
        '- Target areas: {0}\n  An error was returned from the security unit.\n  Perform the operation again.\n（Error Code：FE-CU7-C0013）\n',
      以下の問題: 'Security could not be started in some areas due to the following problem.\n',
      以下の問題から解除:
        'Security could not be deactivated in some areas due to the following problem.\n',
      戸締まり異常:
        '  The lock-up status is abnormal.\n  Please check the lock-up.\n（Error Code：FE-CU7-C0014）\n',
      対象地区: '- Target areas: {0}\n',
    },
  },
  // FE-CU08_ホームセキュリティ画面 path: "/homeSecurity",pages/homeSecurity/HomeSecurity.vue
  FECU08ホームセキュリティ画面: {
    ホームセキュリティ: 'Home Security',
    対象地区一覧ボタン: 'Target Area List',
    通知履歴24時間以内ボタン: 'Notification History \n(within 24 hours)',
    権限: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
      権限: 'Authority',
    },
    最終更新日時: 'Date and time of the last update',
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    通知日付: '{0}/{1}({2})', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    通知時間: '{0}:{1}', //H:mm
    ニックネーム: 'Nickname',
    地区番号: 'Area number',
    加入サービス: 'Subscription service',
    戻るボタン: 'Back',
  },
  // FE-CU09_対象地区詳細画面 path: "/displayDistrictDetail",pages/homeSecurity/AddressDetail.vue
  FECU09対象地区詳細画面: {
    対象地区メニュー: 'Target Area Menu',
    通知履歴24時間以内: 'Notification History \n(within 24 hours)',
    対象地区詳細: 'Target area details',
    対象地区一覧: 'Target Area List',
    権限: 'Authority',
    警備状態: 'Security status',
    警備状態データ: {
      外出ALSOK警備中: 'ALSOK security away mode',
      在宅ALSOK警備中: 'ALSOK security home mode',
      外出セルフ警備中: 'self security away mode',
      在宅セルフ警備中: 'self security home mode',
      警備解除中: 'Security deactivated mode',
      ユーザ点検中: 'User checking mode',
    },
    警報発生: 'Alarm occurrence',
    発報状態: { あり: 'Yes', なし: 'No' },
    戸締まり: 'Lock-up status',
    戸締まり状態: { OK: 'normal', NG: 'abnormal' },
    通知: 'Notification',
    新着通知24時間以内: 'New notifications \n(within 24 hours)',
    ユーザー警備操作: 'User security operation',
    かけつけ依頼: 'Emergency assistance on demand',
    通知履歴: 'Notification history',
    ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
    対象地区設定: 'Target area setting',
    機器制御: 'Device control',
    最終更新日時: 'Date and time of the last update',
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    日付: '{0}/{1}({2})', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    通知時間: '{0}:{1}', //{0}=H,{1}=mm
    HOMEALSOK: 'HOME ALSOK',
    戻るボタン: 'Back',
    //追加
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    メイン地区: 'Main area',
    対象地区: 'Target area',
    // ALSOKへのお問い合わせ
    ALSOKへの: '',
    お問い合わせ: 'Inquiry for ALSOK',
  },
  // FE-CU10_ユーザー警備操作画面 path: "/userSecurityOperation",pages/homeSecurity/securityControl/userSecurityControl/Index.vue
  FECU10ユーザー警備操作画面: {
    ユーザー警備操作: 'User security operation',
    最終操作日時: 'Date and time of the last operation',
    最終操作日時データ: '{0}/{1}/{2}/({3}) {4}:{5}:{6}', //{0}=yyyy,{1}=M,{2}=d,{3}=(ddd),{4}=H,{5}=MM ,{6}=ss",
    最終操作者: 'Final operator',
    警報: 'Alarm occurrence',
    警報データ: {
      異常なし: 'No',
      異常あり: 'Yes',
    },
    戸締り状態: 'Lock-up status',
    戸締り状態データ: {
      異常なし: 'normal',
      異常あり: 'abnormal',
    },
    警備状態: 'Security status',
    警備状態データ: {
      外出ALSOK警備中: 'ALSOK security away mode',
      在宅ALSOK警備中: 'ALSOK security home mode',
      外出セルフ警備中: 'self security away mode',
      在宅セルフ警備中: 'self security home mode',
      警備解除中: 'Security deactivated mode',
      ユーザ点検中: 'User checking mode',
    },
    警備操作: 'Security operation',
    外出: 'Away',
    在宅: 'Home',
    解除: 'Deactivate',
    オンライン: 'ALSOK',
    セルフ: 'Self',
    設定ボタン: 'Setting',
    警報確認: 'Alarm check',
    戸締り確認: 'Lock-up check',
    在宅対象設定: 'Subarea setting',
    戻るボタン: 'Back',
    指定した地区は既に解除状態です: 'The specified area is already deactivated.',
    OKボタン: 'OK',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    在宅対象エリア: 'Subarea - {0}',
    すべて選択ボタン: 'Select All',
    クリアボタン: 'Clear',
    キャンセルボタン: 'Cancel',
    適用ボタン: 'Apply',
    //追加
    対象地区詳細: {
      対象地区: 'Target area',
      カメラ: 'Camera',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    メイン地区: 'Main area',
  },
  // FE-CU12_警報確認画面 path: "/alermConfirmation",pages/homeSecurity/securityControl/AlertConfirm.vue
  FECU12警報確認画面: {
    警報確認: 'Alarm check',
    警報: 'Alarm',
    侵入: 'Intruder',
    非常: 'Emergency / First aid',
    火災: 'Fire',
    ガス: 'Gas',
    ライフリズム: 'Life Rhythm',
    電池: 'Battery',
    機器異常: 'Device error',
    設備: 'Facility',
    戻るボタン: 'Back',
    //追加
    対象地区詳細: {
      対象地区: 'Target areas', //対象地区 - 〇〇
      カメラ: 'Camera', //カメラ - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      メイン地区: 'Main area',
    },
  },
  // FE-CU13_戸締り確認画面 path: "/lockConfirmation",pages/homeSecurity/securityControl/lockedConfirm/Index.vue
  FECU13戸締り確認画面: {
    戸締り確認: 'Lock-up check',
    対象地区詳細表示領域: {
      対象地区: 'Target areas',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      メイン地区: 'Main area',
    },
    センサー状態エリア: 'Sensor status (area)',
    戸締まり状態: {
      異常なし: 'No abnormalities',
      異常: 'Abnormal',
      取得失敗: 'Failed to acquire',
    },
    戻るボタン: 'Back',
    発報中: 'Alarm in progress',
  },
  // FE-CU14_警報確認画面（センサー）path: "/sensorWarningConfirmation",/pages/homeSecurity/securityControl/alertConfirmSensor/Index.vue
  FECU14警報確認画面センサー: {
    警報確認センサー: 'Alarm check (sensor)',
    対象地区詳細表示領域: {
      対象地区: 'Target areas ',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      メイン地区: 'Main area',
    },
    警報名: {
      侵入: 'Intruder',
      火災: 'Fire',
      ガス: 'Gas',
      非常救急: 'Emergency/First aid',
      ライフリズム: 'Life Rhythm',
      設備: 'Facility',
      電池: 'Battery',
      機器異常: 'Device error',
    },
    検知状況: {
      異常なし: 'No abnormalities',
      発報中: 'Alarm in progress',
      異常: 'Abnormal',
      取得失敗: 'Failed to acquire',
    },
    戻るボタン: 'Back',
  },
  // FE-CU15_戸締り確認（エリア）path: "/areaLockConfirmation",pages/homeSecurity/securityControl/lockedConfirmArea/Index.vue
  FECU15戸締り確認エリア: {
    戸締り確認エリア: 'Lock-up check (area)',
    エリア: 'Area',
    対象地区詳細表示領域: {
      対象地区: 'Target areas',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      メイン地区: 'Main area',
    },
    検知状況: {
      異常なし: 'No abnormalities',
      発報中: 'Alarm in progress',
      異常: 'Abnormal',
      取得失敗: 'Failed to acquire',
    },
    戻るボタン: 'Back',
  },
  // FE-CU16_かけつけ依頼画面 path: "/emergencyRequest",/pages/rushInquiry/Index.vue
  FECU16かけつけ依頼画面: {
    かけつけ依頼: 'Emergency assistance on demand',
    対象地区詳細カメラ詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - 〇〇
      カメラ: 'Camera - {0}', //カメラ - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
    },
    メイン地区: 'Main area',
    対象地区: 'Target area',
    カメラ: 'Camera',
    お客様番号: 'Customer number',
    権限: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
    },
    警備状態: 'Security status',
    警備状態データ: {
      外出ALSOK警備中: 'ALSOK security away mode',
      在宅ALSOK警備中: 'ALSOK security home mode',
      外出セルフ警備中: 'self security away mode',
      在宅セルフ警備中: 'self security home mode',
      警備解除中: 'Security deactivated mode',
      ユーザ点検中: 'User checking mode',
    },
    警報発生: 'Alarm occurrence',
    警報発生データ: { あり: 'Yes', なし: 'No' },
    戸締まり: 'Lock-up status',
    戸締まりデータ: { OK: 'normal', NG: 'abnormal' },
    通知: 'Notification',
    担当ガードセンタートパーズセンター: {
      担当ガードセンター: 'Guard center in charge: {0}',
      コールセンター: 'ALSOK Call Center',
    },
    注釈表示領域: {
      担当ガードセンター: {
        架電: 'Call the Guard Center in charge with the phone application.',
        架電画面表示の:
          'Please inform our staff of your customer number displayed on the screen.\nWhen you tell us the name of the area, please inform our staff of "official area name".',
        電話のプランによって: '* You may be charged for the call depending on your phone plan.',
        IP電話アプリや:
          '* If you call from an IP phone application or another phone, contact the above phone number directly.',
        通話料金: '* You may be charged for the call depending on your phone plan.',
        担当ガードセンターへ電話の際は:
          'When you call the Guard Center in charge, please inform our staff of your customer number displayed on the screen.\nWhen you tell us the name of the area, please inform our staff of "official area name".',
      },
      セキュリティサービス部トパーズセンター: {
        SP架電: 'Call the ALSOK Call Center with the phone application.',
        SP架電画面表示の:
          'Please inform our staff of your customer number displayed on the screen.\nWhen you tell us the name of the area, please inform our staff of "official area name".',
        PC架電:
          'When you call the ALSOK Call Center, please inform our staff of your customer number displayed on the screen.\nWhen you tell us the name of the area, please inform our staff of "official area name".',
        電話のプランによって: '* You may be charged for the call depending on your phone plan.',
        IP電話アプリや:
          '* To make a call from an IP phone application or another phone, call the indicated phone number directly.',
      },
      有償です: '* The Emergency Assistance on Demand is a paid service.',
    },
    戻るボタン: 'Back',
  },
  // FE-CU17_通知履歴画面 path: "/notificationHistory",pages/notificationHistory/Index.vue
  FECU17通知履歴画面: {
    通知履歴: 'Notification history',
    全通知ボタン: 'All Notifications',
    ホームセキュリティボタン: 'Home Security',
    カメラボタン: 'Camera',
    お知らせボタン: 'Announcement',
    最終更新日時: 'Date and time of the last update',
    // 最終更新日時データ:"yyyy/M/d H:mm:ss",
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    日付: '{0}/{1}({2})', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', // H:mm
    新着: 'New arrival',
    対象地区: 'Target area',
    警報種別: 'Alarm type',
    カメラ: 'Camera',
    検知種別: 'Detection type',
    対象地区選択: 'Select the Target Area',
    キャンセルボタン: 'Cancel',
    適用ボタン: 'Apply',
    警報種別選択: 'Select alarm type',
    警報種別選択チェックボックス: {
      警備操作: 'Security operation',
      侵入: 'Intruder',
      火災: 'Fire',
      火災復旧: 'Select alarm type',
      ガス: 'Gas',
      ガス復旧: 'Gas recovery',
      非常救急: 'Emergency/First aid',
      非常救急復旧: 'Emergency/First aid recovery',
      ライフリズム: 'Life Rhythm',
      ライフリズム復旧: 'Life Rhythm recovery',
      設備: 'Facility',
      設備復旧: 'Facility recovery',
      電池切れ: 'Low battery',
      電池切れ復旧: 'Dead battery recovery',
      機器異常: 'Device error',
      機器異常復旧: 'Device error recovery',
      お知らせ: 'Announcement',
      見守り: 'Monitoring',
      すべての復旧: 'All recoveries',
      その他: 'Other',
    },
    検知種別選択チェックボックス: {
      動体検知: 'Motion detection, Low battery',
      その他: 'Other',
    },
    種別: 'Category',
    ホーム: 'Home',
    セキュリティ: 'Security',
    お知らせ: 'Announcement',
    ユーザー名: '[Application]',
    // 追加
    戻るボタン: 'Back',
    カメラ選択: 'Select camera',
    検知種別選択: 'Select detection type',
    全て選択: 'Select All',
    クリア: 'Clear',
    複数選択中: 'Multiple selections',
    全て: 'All',
    通知メッセージ: {
      前回ログイン以降の通知: 'Notifications since last login',
      以前の通知を表示: 'Show previous notifications',
      以降の通知を表示: 'Show later notifications',
      __が発生しました: '［{0}］ occurred.',
      警備ユニットが__をセットしました: 'E 警備ユニットが［{0}］をセットしました。', //未使用
      __をセットしました: '［{0}］was activated.',
      見守り監視は: 'The Security Monitoring is now',
      です: '.',
      見守り状態を__しました: 'E 見守り状態を［{0}］しました。', //未使用
      見守りは__しました: 'E 見守りは［{0}］しました。', //未使用
      見守りの__しました: 'E 見守りの［{0}］しました。', //未使用
      見守り監視に: '',
      が発生しています: ' has occurred in the Security Monitoring.',
      見守り監視が__しました: 'The Security Monitoring is now [{0}].',
      見守りの__が完了しました: 'E 見守りの［{0}］が完了しました。', //未使用
      __が解消しました: '［{0}］ was resolved.',
      見守り監視に__が発生しました: '［{0}］has occurred in the Security Monitoring.',
      __を解除しました: '［{0}］was deactivated.',
      __しました: '［{0}］was performed.',
      __が復旧しました: '［{0}］ was recovered.',
      になりました: 'was indicated.',
      見守り監視は__しました: 'The Security Monitoring is now [{0}].',
      見守り監視は__を解除しました: 'In the Security Monitoring, [{0}] was deactivated.',
      カメラが__しました: '[{0}] was received from the camera.',
      カメラが: 'The camera is now',
      になりましたC: '.',
      カメラの__が解消しました: '[{0}] of the camera has been resolved.',
      詳細は: 'For details, see',
      コチラ: 'here',
      侵入警報: 'Intruder alarm',
      火災警報: 'Fire alarm',
      ガス警報: 'Gas alarm',
      CO警報: 'CO alarm',
      非常警報: 'Emergency alarm',
      救急警報: 'First aid alarm',
      ライフリズム警報: 'Life Rhythm alarm',
      設備警報: 'Facility alarm',
      A06: 'A06 Check the power connection.',
      停電警報: 'Power failure',
      A07: 'A07 Charge the battery.',
      ローバッテリー: 'Low battery',
      A08: 'A08 Please contact ALSOK.',
      保護警報: 'Protection alarm',
      A10: 'A10 Please contact ALSOK.',
      警備ユニット異常: 'Security unit error',
      A11: 'A11 Please contact ALSOK.',
      A12: 'A12 Please contact ALSOK.',
      A17: 'A17 Please contact ALSOK.',
      端末異常警報: 'Terminal error alarm',
      無線端末異常: 'Wireless terminal error',
      A18: 'A18 Please contact ALSOK.',
      A15: 'A15 Please contact ALSOK.',
      機器故障: 'Equipment failure',
      A16: 'A16 Please contact ALSOK.',
      メッセージ認証不一致: 'Message authentication mismatch',
      A13: 'A13 Check the network condition, and contact ALSOK if the condition does not improve.',
      通信異常: 'Communication error',
      A14: 'A14 Check the network condition, and contact ALSOK if the condition does not improve.',
      断線: 'Disconnected',
      外出ALSOK警備: 'Away-ALSOK Security Mode',
      在宅ALSOK警備: 'Home-ALSOK Security Mode',
      外出セルフ警備: 'Self security away mode',
      在宅セルフ警備: 'Self security home mode',
      警備解除: 'Deactivated Mode',
      強制警備: 'Compulsory security',
      M02: 'M02 Replace the battery.',
      電池電圧低下: 'Battery voltage reduction',
      M03: 'M03 Unplug other equipment from the power outlet.',
      過負荷: 'Overload',
      異常: 'Abnormal',
      定刻通報: 'Scheduled notification',
      異常通報: 'Abnormality notification',
      監視停止中: 'Monitoring under suspension',
      定刻異常中: 'Scheduled time abnormal',
      見守り操作忘れ異常通報: 'Notification of a security operation omission abnormality',
      正常: 'Normal',
      復旧: 'Recovery',
      定期連絡: 'Regular communication',
      定刻連絡: 'Scheduled communication',
      異常通知: 'Abnormality notification',
      見守り監視: 'Security monitoring',
      定刻正常: 'Scheduled time normal',
      設定変更完了: 'Configuration change completed',
      強制監視停止状態: 'Mandatory monitoring suspended',
      動体検知: 'Motion detection',
      '002': '002 Charge the camera.',
      オフライン: 'Offline',
      '003':
        '003 Check the network condition, and contact ALSOK if the condition does not improve.',
      オンライン: 'online',
      外出ALSOK警備操作: 'ALSOK security away mode',
      在宅ALSOK警備操作: 'ALSOK security home mode',
      外出セルフ警備操作: 'Self security away mode',
      在宅セルフ警備操作: 'Self security home mode',
      警備解除操作: 'Security deactivated mode',
      ALSOKからのお知らせ: 'Message from ALSOK',
      定期通報: 'Regular notification',
    },
  },
  // FE-CU18_ALSOKへのお問い合わせ画面 path: "/contact",pages/inquiry/aboutContactAndItem/Index.vue
  FECU18ALSOKへのお問い合わせ画面: {
    ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
    対象地区詳細カメラ詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - 〇〇
      カメラ: 'Camera', //カメラ - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム: 'Nickname \n(target area)',
    },
    お客様番号: 'Customer number',
    その他のお問い合わせ: 'Other Inquiries',
    受注事業所: 'Business office that accepted the order: {0}', //受注事業所：●●
    受付時間: '[Reception hours] Weekdays 9:00-18:00',
    警報機器トラブルに関するお問い合わせ: 'Inquiries about alarm and equipment trouble', // 警報・機器トラブルに関するお問い合わせ
    ガードセンター: 'Guard center: {0}', // ガードセンター：●●,
    トパーズセンター: {
      電話番号: '0120-352-413',
    },
    ALSOKの事業所案内: 'Information on ALSOK offices',
    フリーダイヤル: {
      見出し: 'Free dial',
      電話番号: '0120-39-2413',
    },
    注釈表示領域: {
      // 受注事務所:
      //   "電話アプリにて受注事業所へ電話を掛けます。\n※事業所の営業時間外はつながらない場合がございます。予めホームページ等をご確認ください。\n※電話のプランによって通話料金が発生する場合があります。\n※IP 電話アプリや、別の電話機から電話発信する場合は、上記電話番号に直接ご連絡ください。",
      受注事務所:
        'Call ALSOK with the phone application.\nThe contact information differs depending on the content of your inquiry, so please check the information on the screen.',
      事業所の営業時間外:
        '* You may not be able to reach us on your phone after the business hours of our office.\nPlease check our website in advance.',
      電話のプランによって: '* You may be charged for the call depending on your phone plan.',
      IP電話アプリや:
        '* If you call from an IP phone application or another phone, contact the above phone number directly.',
      // 事業所:
      //   "事業所へ電話の際は、画面表示のお客様番号を申し伝えください。\n※事業所の営業時間外はつながらない場合がございます。予めホームページ等をご確認ください。\n※電話のプランによって通話料金が発生する場合があります。",
      事業所:
        'If your customer number is displayed on the screen, please inform our staff of your number when you contact us for an inquiry.When you tell us the name of the area, please inform our staff of "official area name".',
    },
    戻るボタン: 'Back',
    // 翻訳対象抽出にはなかったが追加
    担当ガードセンター: 'Guard center in charge: {0}',
    メイン地区: 'Main area',
  },
  // FE-CU19_対象地区設定画面 path: "/displayDistrictSettings",pages/homeSecurity/displayAreaSetting/Index.vue
  FECU19対象地区設定画面: {
    対象地区設定: 'Target area setting',
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    ニックネーム設定: 'Nickname setting',
    対象地区のニックネームの変更: "Change the target area's nickname",
    IDカードキー情報設定: 'ID card/key information setting',
    IDカード操作で表示されるユーザーの情報登録:
      'Settings for ID card/key nicknames, and for enabling/disabling them',
    通知配信設定: 'Notification delivery setting',
    通知送信のONOFF: 'ON/OFF of notification transmission',
    見守り情報配信設定: 'Monitoring information delivery setting',
    見守り情報の配信設定: 'Monitoring information delivery setting',
    戻るボタン: 'Back',
    //追加
    対象地区: 'Target area',
    メイン地区: 'Main area',
  },
  // FE-CU20_ニックネーム設定画面 path: "/setDisplayDistrictNickname",pages/homeSecurity/displayAreaSetting/nickname/Index.vue
  FECU20ニックネーム設定画面: {
    ニックネーム設定: 'Nickname setting (target area)',
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - 〇〇
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      // 追加
      地区名: 'Official area name',
    },
    ニックネーム: 'Nickname',
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    エラーメッセージ表示領域: 'Registration failed.\nPlease register again.',
    OKボタン: 'OK',
    // 追加分
    お知らせ: 'Announcement',
    閉じる: 'Close',
    完了: 'Finish',
    対象地区: 'Target area',
    メイン地区: 'Main area',
  },
  // FE-CU21_IDカード/キー情報設定画面 path: "/idCardKeySettings",pages/homeSecurity/displayAreaSetting/IdCardKeyInfo.vue
  FECU21IDカードキー情報設定画面: {
    IDカードキー情報設定: 'ID card/key information setting',
    対象地区詳細領域: {
      対象地区: 'Target areas - {0}', //"対象地区 - ●● （対象地区名）が後ろに入る
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    カードキー情報: 'Card/Key information',
    ニックネーム: 'Nickname',
    有効: 'Valid',
    無効: 'Invalid',
    設定ボタン: 'Setting',
    //PCの場合のみ表示部
    有効無効: 'Valid/Invalid',
    戻るボタン: 'Back',
    //追加
    対象地区: 'Target area',
    メイン地区: 'Main area',
    設定が完了しました: 'Setup is completed.',
  },
  // FE-CU22_通知配信設定画面 path: "/displayDistrictNotificationDeliverySettings",pages/homeSecurity/displayAreaSetting/NotificationSettingDisplayArea.vue
  FECU22通知配信設定画面: {
    通知配信設定: 'Communication delivery setting',
    対象地区詳細領域: {
      対象地区: 'Target areas',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    PUSH通知: 'PUSH notifications',
    通知するPUSH通知: 'Send notifications',
    通知しないPUSH通知: 'Do not send notifications',
    Eメール通知: 'Email notifications',
    通知するEメール通知: 'Send notifications',
    通知しないEメール通知: 'Do not send notifications',
    すべて選択ボタン_PUSH通知: 'Select All',
    クリアボタン_PUSH通知: 'Clear',
    警備操作: 'Security operation',
    侵入: 'Intruder',
    火災: 'Fire',
    火災復旧: 'Fire - Recovery',
    ガス: 'Gas',
    ガス復旧: 'Gas - Recovery',
    非常緊急: 'Emergency / First aid',
    非常緊急復旧: 'Emergency / First aid - Recovery',
    ライフリズム: 'Life Rhythm',
    お知らせ: 'Announcement',
    全て選択ボタンEメール通知: 'Select All',
    クリアボタンEメール通知: 'Clear',
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    //スマホの場合 通知配信設定チェックボックス表示領域
    //PCの場合 通知配信設定チェックボックス表示領域
    //表示部
    ライフリズム復旧: 'Life-Rhythm - Recovery',
    設備: 'Facility',
    設備復旧: 'Facility - Recovery',
    電池切れ: 'low-battery',
    電池切れ復旧: 'Dead battery - Recovery',
    機器異常: 'Device error (self security only notifications)',
    機器異常復旧: 'Device error - Recovery (self security only notifications)',
    //追加分
    通知内容選択: 'Select Notification Content',
    設定が完了しました: 'Setup is completed.',
    登録に失敗しました: 'Registration failed.\nPlease register again.',
    対象地区: 'Target area',
    メイン地区: 'Main area',
  },
  // FE-CU23_見守り情報配信設定画面 path: "/watchOverInfoDeliverySettings",pages/homeSecurity/displayAreaSetting/WatcherInfo.vue
  FECU23見守り情報配信設定画面: {
    見守り情報配信設定: 'Monitoring information delivery setting',
    対象地区詳細領域: {
      対象地区: 'Target areas', //「対象地区 - ●●」（対象地区名）が後ろに入る
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    見守り情報配信: 'Monitoring information delivery',
    使用する: 'Use',
    使用しない: 'Do not use',
    定期連絡: 'Regular communication',
    異常通知: 'Abnormality notification',
    定刻連絡: 'Scheduled communication',
    見守り設定時間: 'Scheduled communication time (60 to 900 minutes)',
    見守り設定時間定期連絡時間: 'Regular communication time (60 to 900 minutes)',
    見守り設定時間異常通知時間: 'Abnormality notification time(60 to 900 minutes)',
    分: 'minutes',
    定刻連絡時刻: 'Scheduled communication time',
    時刻1: '(1)',
    時刻2: '(2)',
    時刻3: '(3)',
    操作忘れ監視タイマ: 'Operation omission monitoring timer (1 to 99 hours)',
    監視する: 'Monitor',
    時間: 'hours',
    配信許可設定: 'Delivery permission setting',
    配信時間を指定: 'Specify the delivery time',
    波マーク: '{0}:{1} to {2}:{3}', //HH:MM〜HH:mm
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    警備ユニットの取得に失敗しました:
      'Failed to communicate with the security unit.\nRefresh the screen.',
    //追加
    対象地区: 'Target area',
    通知する: 'Send notifications',
    通知しない: 'Do not send notifications',
    見守り方法: 'Monitoring method',
    設定時間: 'time (5 to 900 minutes)',
    メイン地区: 'Main area',
  },
  // FE-CU24_機器制御画面 path: "/equipmentControl",pages/machineControl/Index.vue
  FECU24機器制御画面: {
    機器制御: 'Device control',
    対象地区詳細領域: {
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    No: 'No',
    装置名称: 'Device name',
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    //追加分
    登録が完了しました: 'Registration is completed.',
    メイン地区: 'Main area',
    対象地区: 'Target area',
  },
  // FE-CU25_カメラ画面 path: "/camera",pages/camera/Camera.vue
  FECU25カメラ画面: {
    カメラ: 'Camera',
    カメラ一覧ボタン: 'Camera List',
    通知履歴ボタン: 'Notification History\n(within 24 hours)',
    権限メインユーザー: 'Main user',
    権限サブユーザー: 'Sub-user',
    加入サービス: 'Subscription service',
    最終更新日時: 'Date and time of the last update',
    最新更新日時データ: 'yyyy/M/d H:mm:ss',
    //日付の部分 FE-CU8共通
    日付: '{0}/{1}({2})', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', //H:mm
    権限: 'Authority',
    //追加
    カメラメニュー: 'Camera menu',
    戻るボタン: 'Back',
  },
  // FE-CU26_カメラ詳細画面 path: "/cameraDetail",pages/camera/CameraDetail.vue"
  FECU26カメラ詳細画面: {
    カメラ: 'Camera',
    カメラ詳細表示領域: {
      カメラ詳細: 'Camera - {0}', //「カメラ - ●●」(カメラ詳細)が後ろに入る
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
    },
    カメラ映像: 'Camera image',
    かけつけ依頼: 'Emergency assistance on demand',
    通知履歴: 'Notification history',
    // ALSOKへのお問い合わせ
    ALSOKへの: '',
    お問い合わせ: 'Inquiry for ALSOK',
    カメラ設定: 'Camera setting',
    最終更新日時: 'Date and time of the last update',
    最新更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //yyyy/M/d H:mm:ss
    //日付の部分 FE-CU8共通
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', //H:mm
    戻るボタン: 'Back',
    //追加
    カメラ詳細: 'Camera detail',
    通知履歴ボタン: 'Notification History\n(within 24 hours)',
    カメラメニュー: 'Camera menu',
    メイン地区: 'Main area',
  },
  // FE-CU27_カメラ設定画面 path: "/cameraSettings", pages/camera/CameraSetting.vue"
  FECU27カメラ設定画面: {
    カメラ設定: 'Camera setting',
    カメラ: 'Camera',
    カメラ詳細表示領域: {
      カメラ詳細: 'Camera', //「カメラ - ●●」(カメラ詳細)が後ろに入る
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname \n(target area)',
      デバイスID: 'Device ID',
    },
    ニックネーム設定: 'Nickname setting',
    カメラのニックネームの変更: 'Change the camera nickname',
    通知配信設定: 'Notification delivery setting',
    通知送信のONOFF: 'ON/OFF of notification transmission',
    戻るボタン: 'Back',
    対象地区: 'Target area',
    メイン地区: 'Main area',
  },
  // FE-CU28_ニックネーム設定画面（カメラ） path: "/setCameraNickname",pages/camera/cameraSetting/CameraNickname.vue
  FECU28ニックネーム設定画面カメラ: {
    カメラ: 'Camera',
    ニックネーム設定: 'Nickname setting',
    カメラ詳細表示領域: {
      カメラ詳細: 'Camera - {0}', //「カメラ - ●●」（カメラ詳細）が後ろに入る
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname\n(target area)',
      デバイスID: 'Device ID',
    },
    ニックネーム: 'Nickname',
    ニックネーム入力フォーム: {
      設定ボタン: 'Setting',
      戻るボタン: 'Back',
    },
    OKボタン: 'OK',
    // 追加
    spTitle: 'Nickname setting',
    メイン地区: 'Main area',
  },
  // FE-CU29_通知配信設定画面（カメラ） path: "/cameraNotificationDeliverySettings",pages/camera/cameraSetting/CameraNotificationSetting.vue
  FECU29通知配信設定画面カメラ: {
    通知配信設定: 'Notification delivery setting',
    カメラ詳細表示領域: {
      カメラ詳細: 'Camera',
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname\n(target area)',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    PUSH通知: 'PUSH notifications',
    通知する: 'Send notifications',
    通知しない: 'Do not send notifications',
    すべて選択ボタン: 'Select All',
    クリアボタン: 'Clear',
    動体検知_ローバッテリー: 'Motion detection, Low battery',
    Eメール通知: 'Email notifications',
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    通知内容選択: 'Select Notification Content',
  },
  // FE-CU30_ハウスサポート等お問い合わせ画面 path: "/contactUsHouseSupport",pages/houseSupport/Index.vue
  FECU30ハウスサポート等お問い合わせ画面: {
    //タイトル部
    健康相談等: 'Health consultation, etc.',
    //表示部
    注釈表示領域: {
      // 電話アプリにて相談窓口へ電話を掛けます:
      //   "電話アプリにて相談窓口へ電話を掛けます。画面表示のお客様番号を申し伝えください。\n※電話のプランによって通話料金が発生する場合があります。\n※IP 電話アプリや、別の電話機から電話発信する場合は、下記電話番号に直接ご連絡ください。",
      電話アプリにて相談窓口へ電話を掛けます:
        'For various services, phone numbers and links to our web pages are displayed for inquiries.',
      電話のプランによってIP: '* You may be charged for the call depending on your phone plan.',
      電話のプランによってIP注釈:
        '* If you call from an IP phone application or another phone, contact the displayed phone number directly.',
      // 相談窓口へ電話の際は:
      //   "相談窓口へ電話の際は、画面表示のお客様番号を申し伝えください。\n※電話のプランによって通話料金が発生する場合があります。",
      相談窓口へ電話の際は:
        'For various services, phone numbers and links to our web pages are displayed for inquiries.',
      電話のプランによって: '* You may be charged for the call depending on your phone plan.',
    },
    //お問い合わせ表示部
    Webサイト: 'Web site',
    戻るボタン: 'Back',
    // 追加分
    相談窓口: 'Consultation Service',
    受付時間: '[Reception hours]',
    ハウスサポート: 'Eハウスサポート',
  },
  // FE-CU31_各種設定画面 path: "/variousSettings",pages/variousSettings/Index.vue
  FECU31各種設定画面: {
    //タイトル部
    各種設定: 'Various settings',
    アカウント管理_ログイン方法設定: 'Account management, Login method setting',
    //表示部
    アカウント管理_対象地区: 'Account management \n(target area)',
    対象地区に紐づくサブユーザーの登録削除: 'Register/Delete sub-users related to the target area',
    アカウント管理_カメラ: 'Account management \n(camera)',
    カメラに紐づくサブユーザーの登録削除: 'Register/Delete sub-users related to the camera',
    アカウント管理_ユーザー情報: 'Account management \n(user information)',
    ユーザー情報の登録削除: 'Register/Delete user information',
    ログイン方法設定: 'Login method setting',
    ログイン方法の設定: 'Set the login method when using the application',
    //PC表示部
    戻るボタン: 'Back',
    // 追加
    対象地区: 'Target area',
    カメラ: 'Camera',
    ログイン: 'Login',
    ユーザー情報: 'User information',
  },
  // FE-CU32_アカウント管理（対象地区）画面 path: "/displayDistrictAccountManagement",pages/accountManagement/displayDistrict/Index.vue
  FECU32アカウント管理対象地区画面: {
    アカウント管理_対象地区: 'Account management (target area)',
    ユーザー権限データ: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
    },
    ユーザー管理: 'User management',
    ユーザー管理変更ボタン: 'Change',
    緊急連絡先: 'Emergency contact',
    緊急連絡策変更ボタン: 'Change',
    お客様番号: 'Customer number',
    警備先名: 'Name of the destination for security',
    地区番号: 'Area number',
    地区名: 'Official area name',
    戻るボタン: 'Back',
    デバイスID: 'Device ID',
    メイン地区: 'Main area',
  },
  // FE-CU33_アカウント管理（カメラ）画面 path: "/cameraAccountManagement",pages/accountManagement/camera/Index.vue
  FECU33アカウント管理カメラ画面: {
    アカウント管理_カメラ: 'Account management (camera)',
    アカウント管理_対象地区: 'Account management (target area)',
    お客様番号: 'Customer number',
    警備先名: 'Name of the destination for security',
    ユーザー管理: 'User management',
    緊急連絡先: 'Emergency contact',
    地区番号: 'Area number',
    ユーザー権限データ: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
    },
    ユーザー管理変更ボタン: 'Change',
    緊急連絡策変更ボタン: 'Change',
    削除ボタン: 'Delete',
    戻るボタン: 'Back',
    削除: 'Delete',
    カメラ_ニックネーム: 'Camera (nickname)',
    デバイスID: 'Device ID',
    閉じるボタン: 'Close',
    地区名: 'Official area name',
    // 追加
    登録に失敗しました: 'Provisional registration failed.\nPlease register again.',
    メイン地区: 'Main area',
  },
  // FE-CU34_アカウント管理(ユーザー情報)画面 path: "/userInfoAccountManagement",pages/accountManagement/userInfo/Index.vue
  FECU34アカウント管理ユーザー情報画面: {
    アカウント管理ユーザー情報: 'Account management (user information)',
    氏名: 'Name',
    // 性別任意: "性別(任意)",
    性別: 'Gender',
    // 生年任意: "生年(任意)",
    生年: 'Birth year',
    任意: '(optional)',
    生年データ: '{0}year', //yyyy年
    ユーザーIDメールアドレス: 'User ID (email address)',
    パスワード: 'Password',
    秘密の質問: 'Secret question',
    戻るボタン: 'Back',
    アカウント削除ボタン: 'Delete Account',
    //追加
    未指定: 'Unspecified',
    男性: 'Male',
    女性: 'Female',
    年: 'Year',
    変更: 'Change',
    ユーザーID: 'User ID',
    メールアドレス: '(email address)',
  },
  // FE-CU35_ログイン方法設定画面 path: "/loginSettings",pages/loginSettings/Index.vue
  FECU35ログイン方法設定画面: {
    ログイン方法設定: 'Login method setting',
    ユーザーIDパスワードを毎回入力する: 'Enter your user ID and password each time',
    アプリを使用する際ユーザーIDとパスワードを入力のうえログインする必要があります:
      'When you use the application, you need to log in with your user ID and password.',
    ユーザーIDは省略しパスワードを入力する: 'Enter the password without entering the user ID',
    次回ログイン時からパスワードの入力だけでログインできます:
      'You can log in only by entering your password from the next time you log in.\nYour user ID is automatically entered in the user ID entry field.',
    パスコードスマートフォンの生体認証を使う:
      "Use a passcode or smartphone/tablet's biometric authentication",
    ユーザーIDパスワードの替わりに数字4桁のパスコードだけでログインできます:
      'You can log in with a 4-digit passcode or biometric authentication installed in your smartphone or tablet.\nTo use biometric authentication, select "Set biometric authentication" after setting the passcode.',
    設定ボタン: 'Setting',
    設定された内容で登録します: 'The content you entered will be registered. \nOK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    設定が完了しました: 'Setup is completed.',
    閉じるボタン: 'Close',
    //追加
    確認: 'Confirm',
    お知らせ: 'Announcement',
    ヘルプ:
      'You need to set up the login method for each smartphone you use. You can change the login method at any time by selecting the Menu button => Settings => Set Login Method.',
  },
  // FE-CU36_パスコード設定画面 path: "/passcodeSettings",pages/passcodeSettings/Index.vue
  FECU36パスコード設定画面: {
    パスコード4桁を入力してください: 'Enter a 4-digit passcode',
    もう一度入力してください: 'Please enter it again',
    パスコードの設定が完了しました生体情報が登録されていません:
      'Passcode setting is completed.\nNo biometric information is registered.\nDo you want to open the setting and set up biometrics?',
    生体認証を設定: 'Yes',
    設定を終了: 'No',
    //追加
    パスコード設定: 'Passcode setting ',
    パスコード設定完了: 'Passcode setting is completed.',
  },
  // FE-CU37_ユーザー管理画面 path: "/userManagement",pages/userManagement/Index.vue
  FECU37ユーザー管理画面: {
    対象地区詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
      デバイスID: 'Device ID',
    },
    ユーザー一覧: 'User list',
    ユーザーIDメールアドレス: 'User ID (email address)',
    氏名: 'Name',
    ユーザーの権限: 'User authorities',
    ユーザーの権限データ: {
      メインユーザー: 'Main user',
      サブユーザー: 'Sub-user',
    },
    変更ボタン: 'Change',
    戻るボタン: 'Back',
    サブユーザー追加ボタン: 'Add Sub user',
    メインユーザー移譲ボタン: 'Transfer the Main User',
    //追加
    ユーザー管理: 'User management',
    ユーザーID: 'User ID',
    メールアドレス: '(email address)',
    権限: 'Authority',
    メイン地区: 'Main area',
  },
  // FE-CU38_サブユーザー権限変更画面 path: "/subUserAuthorityChange",pages/subUserAuthorityChange/Index.vue
  FECU38サブユーザー権限変更画面: {
    サブユーザー権限変更: 'Change sub-user authorities',
    対象地区: 'Target area',
    対象地区詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname\n(target area)',
    },
    カメラ: 'Camera',
    カメラ詳細表示領域: {
      カメラ: 'Camera', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    氏名: 'Name',
    ユーザーIDメールアドレス: 'User ID (email address)',
    サブユーザーの操作権限: 'Sub-user operating authorities',
    おすすめボタン: 'Recommendation',
    警備操作: 'Security operation',
    かけつけ依頼: 'Emergency assistance on demand',
    通知通知履歴: 'Notifications/Notification history',
    機器制御: 'Device control',
    ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
    ニックネーム設定対象地区: 'Nickname setting (target area)',
    IDカードキー情報設定: 'ID/Card key information setting',
    見守り情報配信設定: 'Monitoring information delivery setting',
    戸締り確認: 'Lock-up check',
    在宅対象設定: 'Subarea setting',
    ユーザー管理: 'User management',
    緊急連絡先: 'Emergency contact',
    対象地区から除外する: 'Exclude from the target area',
    カメラから除外する: 'Exclude from the camera',
    対象地区から本ユーザーが除外されます: '* Exclude this user from the target area.',
    カメラから本ユーザーが除外されます: '* Exclude this user from the camera.',
    本操作にて:
      '* If this operation results in 0 target areas/cameras related to this user, the user information is deleted.',
    本操作にてカメラ:
      '* If this operation results in 0 target areas/cameras related to this user, the user information is deleted.',
    カメラ映像: 'Camera image',
    ニックネーム設定カメラ: 'Nickname setting (camera)',
    設定ボタン: 'Setting',
    設定された内容で登録します: 'The content you entered will be registered.',
    よろしいでしょうか: 'OK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    警報確認: 'Alarm check',
    登録に失敗しました: 'Setup failed. ',
    もう一度設定してください: 'Setup failed. Please perform the setup again.',
    OKボタン: 'OK',
    //追加
    ユーザーID: 'User ID',
    確認: 'Confirm',
    設定が完了しました: 'Setup is completed.',
    エラー: 'Error',
    戸締り確認警報確認: 'Lock-up/Alarm check',
    戻るボタン: 'Back',
    メイン地区: 'Main area',
  },
  // FE-CU39_新規サブユーザー登録画面（仮登録） path: "/subUserTempRegistration",pages/subUserTempRegistration/Index.vue
  FECU39新規サブユーザー登録画面仮登録: {
    対象地区詳細表示領域: {
      対象地区: 'Target areas ', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera ', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
      デバイスID: 'Device ID',
    },
    以下のメールアドレスに本登録用のURLを発行する:
      'Issue a URL for registration to the following email address.',
    メールアドレス: 'Email address',
    確認用: 'For confirmation',
    サブユーザーの操作権限: 'Sub-user operating authorities',
    おすすめボタン: 'Recommendation',
    警備操作: 'Security operation',
    かけつけ依頼: 'Emergency assistance on demand',
    通知通知履歴: 'Notifications/Notification history',
    機器制御: 'Device control',
    ALSOKへのお問い合わせ: 'Inquiry for ALSOK',
    ニックネーム設定対象地区: 'Nickname setting (target area)',
    IDカードキー情報設定: 'ID card/key information setting',
    見守り情報配信設定: 'Monitoring information delivery setting',
    戸締り確認: 'Lock-up check',
    在宅対象設定: 'Subarea setting',
    ユーザー管理: 'User management',
    緊急連絡先: 'Emergency contact',
    カメラ映像: 'Camera image',
    ニックネーム設定カメラ: 'Nickname setting (camera)',
    仮登録: 'Provisional Registration',
    戻るボタン: 'Back',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    OKボタン: 'OK',
    閉じるボタン: 'Close',
    警報確認: 'Alarm check',
    //追加
    新規サブユーザー登録仮登録: 'New sub-user registration (temporary registration)',
    対象地区から本ユーザーが除外されます: '* This user will be excluded from the target area.',
    本操作にて対象地区:
      '* After this operation, if you become a sub-user who is not associated with the target area/camera, the sub-user will be deleted.',
    戸締り確認警報確認: 'Lock-up/Alarm check',
    確認: 'Confirm',
    エラー: 'Error',
    メイン地区: 'Main area',
  },
  // FE_CU40 メインユーザー移譲画面 path: "/mainUserTransfer",pages/mainUserTransfer/Index.vue"
  FECU40メインユーザー移譲画面: {
    メインユーザー移譲: 'Transfer the Main User',
    対象地区詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname \n(target area)',
      デバイスID: 'Device ID',
    },
    ユーザーIDメールアドレス: 'User ID (email address)',
    氏名: 'Name',
    ユーザーの権限: 'User authorities',
    移譲ボタン: 'Transfer',
    戻るボタン: 'Back',
    メインユーザー: {
      移譲前: 'Main user (before transfer)',
      移譲後: 'Main user (after transfer)',
      メインユーザー: 'Main user',
    },
    いいえボタン: 'No',
    はいボタン: 'Yes',
    中止ボタン: 'Quit',
    続行ボタン: 'Continue',
    //追加
    ユーザーID: 'User ID',
    サブユーザー: 'Sub-user',
    メールアドレス: 'email address',
    確認: 'Confirm',
    アカウント管理_対象地区: 'Account management (target area)',
    メイン地区: 'Main area',
  },
  // FE_CU41 承認/可否選択画面 path: "/approvalSelect",pages/approvalSelect/Index.vue"
  FECU41承認可否選択画面: {
    承認可否選択: 'Select approve/reject',
    メインユーザーによって:
      'The main user is about to transfer the main user of the following {0} to you. \nAre you sure you want to change?',
    他のユーザによって: 'Another user is about to add you as a sub-user of the following {0}.',
    サブユーザーの登録:
      '\nAre you sure you want to be registered as a sub-user of the following {0}?',
    メールアドレスの登録: 'Are you sure you want to change your email address?',
    対象地区詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    メインユーザー: {
      移譲前: 'Main user (before transfer)',
      移譲後: 'Main user (after transfer)',
    },
    移譲前ユーザーID: 'User ID',
    移譲後ユーザーID: 'User ID',
    移譲前氏名: 'Name',
    否認ボタン: 'Reject',
    承認ボタン: 'Approve',
    変更を承認します: 'Approve the changes.\nOK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    変更を否認します: 'Reject the changes.\nOK?',
    変更を承認しました: 'The changes have been approved.',
    ログイン画面へ: 'To the Login Screen',
    変更を否認しました:
      'The changes have been rejected.\nThe content of the changes has been cancelled.',
    他ユーザーによって以下対象地区のサブユーザーにあなたが追加されようとしています:
      'Another user is about to add you as a sub-user of the following target area.\nAre you sure you want to be registered as a sub-user of the following target area?',
    他ユーザーによって以下カメラのサブユーザーにあなたが追加されようとしています:
      'Another user is about to add you as a sub-user of the following camera.\nAre you sure you want to be registered as a sub-user of the following camera?',
    サブユーザーの登録を承認します: 'Approve the sub-user registration.\nOK?',
    サブユーザーの登録を否認します: 'Reject the sub-user registration.\nOK?',
    サブユーザーの登録を承認しました: 'The sub-user registration has been approved.',
    サブユーザーの登録を否認しました:
      'The sub-user registration has been rejected.\nRegistration has been cancelled.',
    メールアドレスが変更されようとしています: 'Are you sure you want to change your email address?',
    メールアドレス: {
      メールアドレス: 'Email address',
      変更前: 'Email address (before change)',
      変更後: 'Email address (after change)',
    },
    ユーザー情報の変更を承認します: 'Approve changes to the user information.\nOK?',
    ユーザー情報の変更を否認します: 'Reject changes to the user information.\nOK?',
    ユーザー情報の変更を承認しました: 'The changes to the user information have been approved.',
    ユーザー情報の変更を否認しました:
      'The changes to the user information have been rejected.\nThe changes have been cancelled.',
    //追加
    対象地区施設名: 'Name of the destination for security',
    ニックネーム: 'Nickname',
    対象地区: '(target area)',
    カメラ: '(camera)',
    氏名: 'Name',
    警備先名: 'Name of the destination for security',
  },
  // FE-CU42_緊急連絡先設定画面
  FECU42緊急連絡先設定画面: {
    // タイトル部
    緊急連絡先設定: 'Emergency contact setting',
    // 表示部
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname\n(target area)',
      デバイスID: 'Device ID',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera - {0}', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname\n(target area)',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    緊急連絡先: 'Emergency contact',
    同居家族情報: 'Family members information',
    救急情報: 'First Aid Information',
    追加ボタン: 'Add',
    並べ替えボタン: 'Sort',
    氏名: 'Name',
    氏名_プレースホルダー: 'Up to 80 characters (Example: 鈴木太郎)',
    氏名カナ: 'Name (kana)',
    氏名カナ_プレースホルダー: 'Up to 80 characters (Example: スズキタロウ)',
    関係: 'Relationship',
    関係_プレースホルダー: 'Up to 80 characters (Example: 本人)',
    電話番号: 'Phone number',
    電話番号_プレースホルダー: 'Up to 20 half-width numeric characters (Example: 050-1234-5678)',
    変更ボタン: 'Change',
    削除ボタン: 'Delete',
    戻るボタン: 'Back',
    キャンセルボタン: 'Cancel',
    登録ボタン: 'Register',
    // ダイアログ部 重複部分は未記載
    上記緊急連絡先を削除します: 'Delete the emergency contact described above.\nOK?',
    適用ボタン: 'Apply',
    第n連絡先: '{0} emergency contact',
    閉じるボタン: 'Close',
    並び順が適用されました: 'The order has been applied.',
    並び順が適用されていません:
      'The order has not been applied.\nDo you want to go to the next screen?',
    緊急連絡先情報の取得に失敗しました: 'Failed to acquire emergency contact information.',
    緊急連絡先情報が登録されていません: 'No emergency contact information is registered.',
  },
  // FE-CU43_緊急連絡先設定画面-同居家族情報
  FECU43緊急連絡先設定画面同居家族情報: {
    // タイトル部
    緊急連絡先設定: 'Emergency contact setting',
    // 表示部
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname\n(target area)',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera - {0}', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname\n(target area)',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    緊急連絡先: 'Emergency contact',
    同居家族情報: 'Family members information',
    救急情報: 'First Aid Information',
    シークレットコード: 'Secret code',
    同居者様本人確認の際にお伺いいたします:
      'We will ask you when we confirm the identity of the person living with you.',
    シークレットコードカナ: 'Secret code (kana)',
    同居家族: 'Family members',
    追加ボタン: 'Add',
    並べ替えボタン: 'Sort',
    氏名: 'Name',
    氏名_プレースホルダー: 'Up to 20 characters (Example: 鈴木太郎)',
    カナ: 'Name (kana)',
    氏名カナ_プレースホルダー: 'Up to 40 characters (Example: スズキタロウ)',
    続柄: 'Relationship',
    生年月日: 'Date of birth',
    生年月日_プレースホルダー: 'yyyy/mm/dd',
    電話番号: 'Phone number',
    変更: 'Change',
    削除: 'Delete',
    戻るボタン: 'Back',
    シークレットコードフリガナ: 'Secret code (kana)',
    キャンセルボタン: 'Cancel',
    登録ボタン: 'Register',
    // ダイアログ部 重複部分は未記載
    // 入力された内容で登録します:
    //   "入力された内容で登録します。\nよろしいでしょうか。",
    入力された内容で登録します: 'The content you entered will be registered.',
    // 上記同居家族情報を削除します:
    //   "上記同居家族情報を削除します。\nよろしいでしょうか。",
    上記同居家族情報を削除します: "Delete the family members' information displayed.",
    よろしいでしょうか: 'OK?',
    完了: 'Finish',
    同居家族情報の取得に失敗しました:
      'Failed to acquire the information of the family members living together.',
    適用ボタン: 'Apply',
    第1連絡先: '1st emergency contact',
    第2連絡先: '2nd emergency contact',
    第3連絡先: '3rd emergency contact',
    第4連絡先: '4th emergency contact',
    第5連絡先: '5th emergency contact',
    登録が完了しました: 'Registration is completed.',
    削除が完了しました: 'Deletion is completed.',
    追加が完了しました: 'Addition is complete.',
    変更が完了しました: 'Change is complete.',
    閉じるボタン: 'Close',
    並び順が適用されました: 'The order has been applied.',
    並び順が適用されていません:
      'The order has not been applied.\nDo you want to move to the next screen?',
    緊急連絡先情報の取得に失敗しました: 'Failed to acquire emergency contact information.',
    緊急連絡先情報が登録されていません: 'No emergency contact information is registered.',
    //追加
    確認: 'Confirm',
    はいボタン: 'Yes',
    いいえボタン: 'No',
  },
  // FE-CU44_緊急連絡先設定画面-救急情報 path: "/emergencyContact",pages/emergencyContact/Index.vue"
  FECU44緊急連絡先設定画面救急情報: {
    対象地区詳細表示領域: {
      対象地区: 'Target areas - {0}', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム地区表示: 'Nickname\n(target area)',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera - {0}', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    緊急連絡先: 'Emergency contact',
    同居家族情報: "Family members' information",
    救急情報: 'First Aid Information',
    追加ボタン: 'Add',
    氏名: 'Name',
    カナ: 'Name (kana)',
    続柄: 'Relationship',
    生年月日: 'Date of birth',
    変更: 'Change',
    削除: 'Delete',
    戻るボタン: 'Back',
    // 上記救急情報を削除します:
    //   "上記救急情報を削除します。\nよろしいでしょうか。",
    上記救急情報を削除します: 'Delete the first aid information displayed.',
    よろしいでしょうか: 'OK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    救急情報の取得に失敗しました: 'Failed to acquire first aid information.',
    登録が完了しました: 'Registration is completed.',
    削除が完了しました: 'Deletion is completed.',
    閉じるボタン: 'Close',
    並び順が適用されました: 'The order has been applied.',
    並び順が適用されていません:
      'The order has not been applied.\nDo you want to go to the next screen?',
    緊急連絡先情報が登録されていません: 'No emergency contact information is registered.',
    削除に失敗しました: 'Failed to delete.\nPlease perform the operation again.',
    //追加
    確認: 'Confirm',
    完了: 'Finish',
    関係: 'Relationship',
    電話番号: 'Phone number',
    第n連絡先: '{0}emergency contact',
    並べ替え: 'Sort',
    キャンセルボタン: 'Cancel',
    登録ボタン: 'Register',
    同居家族: 'Family members',
    上記緊急連絡先を削除します: 'Delete the emergency contact described above.',
  },
  // FE-CU45_救急情報設定画面 path: "/firstAidInfoSettings",pages/firstAidInfo/FirstAidInfo.vue
  FECU45救急情報設定画面: {
    救急情報設定: 'First aid information setting',
    対象地区詳細表示領域: {
      対象地区: 'Target areas', //対象地区 - ◯◯
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      ニックネーム対象地区: 'Nickname\n(target area)',
    },
    カメラ詳細表示領域: {
      カメラ: 'Camera', //カメラ - ●●
      利用プラン: 'Contract type',
      お客様番号: 'Customer number',
      警備先名: 'Name of the destination for security',
      地区番号: 'Area number',
      地区名: 'Official area name',
      デバイスID: 'Device ID',
    },
    メイン地区: 'Main area',
    氏名: {
      氏名: 'Name',
      氏名_プレースホルダー: 'Up to 20 characters (Example: 鈴木太郎)',
      カナ: 'Name (kana)',
      カナ_プレースホルダー: 'Up to 40 characters (Example: スズキタロウ)',
    },
    性別: 'Gender',
    性別ラジオボタン: {
      男性: 'Male',
      女性: 'Female',
    },
    生年月日: 'Date of birth',
    生年月日_プレースホルダー: 'yyyy/mm/dd',
    既往症病名: 'Previous disease (disease name)',
    既往症病名_プレースホルダー: 'Up to 40 characters (Example: 糖尿病1型)',
    かかりつけ医療機関: 'Family medical institution',
    名称医療機関名: 'Name (name of medical institution)',
    名称医療機関名_プレースホルダー: 'Up to 60 characters (Example: 〇〇市民病院)',
    住所: 'Address',
    住所_プレースホルダー: 'Up to 120 characters (Example: 東京都千代田区1-1 〇〇ビル3F)',
    電話番号: 'Phone number',
    電話番号_プレースホルダー: 'Up to 15 characters (Example: 000-0000-0000)',
    担当医師: 'Doctor in charge',
    担当医師_プレースホルダー: 'Up to 20 characters (Example: 佐藤先生)',
    設定ボタン: 'Setting',
    戻るボタン: 'Back',
    入力された内容で登録します: 'The content you entered will be registered.\nOK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    設定に失敗しました: 'Setup failed.\nPlease perform the setup again.',
    OKボタン: 'OK',
    //追加
    設定が完了しました: 'Setup is completed.',
    名称: 'Name',
    医療機関名: '(name of medical institution)',
  },
  // FE-CU46_サービス追加画面 path: "/serviceAdd",pages/serviceAdd/ServiceAdd.vue
  FECU46サービス追加画面: {
    サービス追加: 'Add a Service',
    本ユーザーが追加したサービスのメインユーザーとして登録されます:
      'This user will be registered as the main user of the added service.',
    追加したいサービス: 'Service you want to add',
    追加したいサービスセレクト: {
      ホームセキュリティ: 'Home Security',
      カメラ: 'Camera',
      その他サービス: 'Other Services',
    },
    お客様番号: 'Customer number',
    認証番号: 'Authentication number',
    認証番号入力フォーム: 'Register',
    デバイスID: 'Device ID',
    ALSOKから提示されたお客様番号認証番号をお持ちの方は入力してください:
      'If you have the customer or authentication number provided by ALSOK, please enter it.',
    登録ボタン: 'Register',
    閉じるボタン: 'Close',
    //追加
    製造番号: 'Serial number',
    戻るボタン: 'Back',
    半角数字6桁: 'Up to 6 half-width numeric characters',
    半角数字9桁: 'Up to 9 half-width numeric characters',
    半角英数字15桁: 'Up to 15 half-width alphanumeric characters',
    半角英数字24桁: 'Up to 24 half-width alphanumeric characters',
  },
  // FE-CU47_ユーザー情報変更画面（氏名, 電話番号）path: "/changeUserInfoOfPersonalData",pages/user/nameEdit/Index.vue
  FECU47ユーザー情報変更画面氏名電話番号: {
    氏名: 'Name',
    性別任意: 'Gender (optional)',
    生年任意: 'Birth year (optional)',
    戻るボタン: 'Back',
    変更ボタン: 'Change',
    //追加分
    ユーザー情報変更: 'User information change',
    未指定: 'Unspecified',
    男性: 'Male',
    女性: 'Female',
    変更が完了しました: 'Change is completed.',
  },
  // FE-CU48_ユーザー情報変更画面（メールアドレス）path: "/changeUserInfoOfUserId",/pages/user/mailAddressEdit/Index.vue
  FECU48ユーザー情報変更画面メールアドレス: {
    ユーザー情報変更: 'User information change',
    ユーザーIDメールアドレス: 'User ID (email address)',
    確認用: 'For confirmation',
    変更ボタン: 'Change',
    戻るボタン: 'Back',
    いいえボタン確認: 'No',
    はいボタン確認: 'Yes',
    現在のパスワード: 'Current password',
  },
  // FE-CU49_ユーザー情報変更画面（パスワード） path: "/changeUserInfoOfPassword",pages/user/passwordEdit/Index.vue
  FECU49ユーザー情報変更画面パスワード: {
    ユーザー情報変更: 'User information change',
    現在のパスワード: 'Current password',
    変更後のパスワード: 'Password after change',
    確認用: 'For confirmation',
    戻るボタン: 'Back',
    変更ボタン: 'Change',
    閉じるボタン: 'Close',
    //追加
    確認: 'Confirm',
    変更が完了しました: 'Change is completed.',
  },
  // FE-CU50_ユーザー情報変更（秘密の質問）path: "/changeUserInfoOfSecretQuestion",pages/user/secretQuestionEdit/Index.vue
  FECU50ユーザー情報変更秘密の質問: {
    ユーザー情報変更: 'User information change',
    秘密の質問: 'Secret question',
    回答: 'Answer (hiragana)',
    変更ボタン: 'Change',
    戻るボタン: 'Back',
    中止ボタン: 'Quit',
    続行ボタン: 'Continue',
    閉じるボタン: 'Close',
    //追加
    確認: 'Confirm',
    変更が完了しました: 'Change is completed.',
  },
  // FE-CU51_アカウント削除画面 path: "/accountDelete",pages/user/Delete.vue
  FECU51アカウント削除画面: {
    ユーザー情報変更: 'Delete Account',
    アカウント削除対象お客様情報: 'Customer information of the account to be deleted',
    氏名: 'Name',
    ユーザーIDメールアドレス: 'User ID (email address)',
    削除の注釈表示領域:
      'Since this account is the main user of Home Security or the Camera, you will not be able to manage sub-users, set emergency contacts, or set ID cards/keys.',
    メインユーザーの権限をサブユーザーに移譲することも出来ます:
      'You can also transfer the authorities of the main user to sub-users.\nIf you need the main user again, you must register the main user again.',
    削除ボタン: 'Delete',
    上記アカウントが削除されます: 'The displayed account will be deleted.',
    戻るボタン: 'Back',
    // あなたはホームセキュリティーまたはカメラにてメインユーザーです:
    //   "あなたは、ホームセキュリティまたはカメラにてメインユーザーです。\nアカウントの削除操作を行いますか。",
    あなたはホームセキュリティーまたはカメラにてメインユーザーです:
      'You are the main user of Home Security or the Camera.',
    アカウントの削除操作を行いますか: 'Do you want to delete the account?',
    中止ボタン: 'Quit',
    継続ボタンメインユーザーの場合: 'Continue',
    パスワードを入力してください: 'Enter your password.',
    削除ボタンパスワード入力ダイアログ: 'Delete',
    閉じるボタン: 'Close',
    // 追加
    警告: 'Warning',
  },
  // FE-CU52_新規メインユーザー登録画面（仮登録）path: "/mainUserTempRegistration",pages/user/temporaryRegistration/Index.vue
  FECU52新規メインユーザー登録画面仮登録: {
    新規メインユーザー登録仮登録: 'New main user registration (provisional registration)',
    本ユーザーが追加したサービスのメインユーザーとして登録されます:
      'This user will be registered as the main user of the added service.',
    追加したいサービス: 'Service you want to add',
    お客様番号: 'Customer number',
    製造番号: 'Serial number',
    認証番号: 'Authentication number',
    ユーザーIDメールアドレス: 'User ID (email address)',
    ユーザーID: 'User ID (email address)',
    確認用: 'For confirmation',
    仮登録ボタンホームセキュリティ: 'Provisional registration',
    デバイスID: 'Device ID',
    ALSOKから提示されたお客様番号認証番号をお持ちの方は入力してください:
      'If you have the customer or authentication number provided by ALSOK, please enter it.',
    仮登録ボタンカメラ: 'Provisional registration',
    戻るボタン: 'Back',
    登録ボタン: 'Register',
    //追加
    ホームセキュリティ: 'Home Security',
    カメラ: 'Camera',
    半角英数字24桁: 'Up to 24 half-width alphanumeric characters',
    半角数字9桁: 'Up to 9 half-width numeric characters',
    半角英数字15桁: 'Up to 15 half-width alphanumeric characters',
    半角数字6桁: 'Up to 6 half-width numeric characters',
  },
  // FE-CU53_ユーザー登録画面（本登録）path: "/userRegistration",pages/user/registration/Index.vue
  FECU53ユーザー登録画面本登録: {
    ユーザー登録本登録: 'User registration (definitive registration)',
    お客様番号: 'Customer number',
    警備先名: 'Name of the destination for security',
    ニックネーム対象地区: 'Nickname \n(target area)',
    ニックネーム対象地区スマホ: { ニックネーム: 'Nickname', 対象地区: '(target area)' },
    氏名: 'Name',
    パスワード: 'Password',
    確認用: 'For confirmation',
    秘密の質問: 'Secret question',
    回答ひらがな: 'Answer (hiragana)',
    性別任意: 'Gender (optional)',
    性別セレクト: { 未指定: 'Unspecified', 男性: 'Male', 女性: 'Female' },
    生年任意: 'Birth year (optional)',
    生年セレクト: { 未指定: 'Unspecified', 生年: '{0}' }, //yyyy
    登録ボタン: 'Register',
    入力された内容でユーザー登録を行います:
      'Register the user with the information you entered.\nOK?',
    いいえボタン: 'No',
    はいボタン: 'Yes',
    //追加
    確認: 'Confirm',
  },
  // FE-CU54_Thanks画面 path: "/thanks",pages/thanks/Index.vue
  FECU54Thanks画面: {
    メッセージ表示領域: {
      メインユーザー仮登録完了: 'Main user provisional registration completed', // C0003
      パスワード初期化受付完了: 'Password re-registration acceptance completed', // C0004
      メインユーザー移譲受付完了: 'Main user transfer acceptance completed', // C0005
      アカウント削除完了: 'Account deletion completed', // C0011
      サブユーザー本登録完了: 'Sub-user registration completed', // C0012
      メインユーザー本登録完了: 'Main user registration completed', // C0013
      パスワード初期化完了: 'Password re-registration completed',
      サービス追加完了: 'Service addition completed', // C0023
      ユーザー情報変更メールアドレス受付完了:
        'Acceptance of user information change (email address) completed', // C0020
    },
    ご登録いただいているメールアドレスに:
      'Email with "{0} (Subject)" has been sent to the registered email address.', //{0}=件名
    // 以下先頭は●分以内
    メッセージ詳細表示領域: {
      本登録:
        'Please complete this registration from the URL provided in the email text within {0} minutes.', // C0006
      パスワード設定:
        'Please enter a secret question from the URL provided in the email text within {0} minutes, and then set a new password.', // C0009
      承認否認操作:
        'Please perform the Approve/Reject operation from the URL provided in the email text within {0} minutes.', // C0007
      アカウントを削除しました: 'The account has been deleted.\nThank you for using our service.', // C0015
      サブユーザーを本登録しました: 'The sub-user has been registered.', // C0016
      メインユーザーを本登録しました: 'The main user has been registered.', // C0017
      パスワードを初期化しました: 'The password has been re-registered.', //C0018
      サービスを追加しました: 'The service has been added.', // C0024
    },
    メールが届かない場合は以下の可能性が考えられます:
      'If you have not received an email, one of the following reasons may be the cause.',
    メールの設定を変更後再度操作を行ってください: 'Change the mail settings and try again.',
    迷惑メールとして処理されている可能性があります: '- It may have been handled as spam.', //先頭○迷惑メール
    迷惑メールフォルダやゴミ箱等に: ' Please check if there is any email with the subject "', //「という件名のメール」との間に「●●」が入る
    という件名のメール: '" in the spam mail folder',
    がないかご確認をお願いいたします: ' trash box, etc',
    //以下先頭に○が入る
    ドメイン指定を行っている方は:
      '- If you have specified a domain, set it so that "{0}" can be received.', //{0}=domain 「を受信できる様に設定してください。」との間に「＠●●」
    ログイン画面へボタン: 'To the Login Screen',
    一定回数以上パスワードを間違えたためアカウントはロックされました:
      'Your account has been locked because you made more than a certain number of mistakes when answering the secret question.',
    パスワードを再設定していただくことでロックは解除可能です:
      'You can unlock the locked account by setting your password again.',
    ロックを解除するには: 'To deactivate the lock,',
    ALSOKの担当事業所までご連絡ください: 'contact the ALSOK office in charge.',
    このワンタイムURLは失効しました: 'This one-time URL has expired.', // C0022
    サービスを追加しました: 'The service has been added.',
    アプリの起動に失敗しました: 'Failed to start the application.',
    もう一度ALSOK営業までご連絡くださいを押してください: 'Press “Please contact {0}.” again. ',
    閉じるボタン: 'Close',
    //追加
    秘密の質問の回答を一定回数以上間違えたためアカウントはロックされました:
      'Your account has been locked because you made more than a certain number of mistakes when answering the secret question.', // C0019
    エラーになりました: 'An error has occurred.\nA required parameter is missing.',
    パスワードリセット: {
      info1: '"{0}" email was sent to the registered email address.',
      info2:
        'Please enter the answer to the secret question from the URL provided in the email text within {0} minutes, and then set a new password.',
      info3:
        'If you have not received the email, the following reasons may be the cause.\nAfter changing the email settings, use the "<" or "Back" button to go to the Login screen and log in again.',
      info4:
        'The email may have been handled as spam.\nPlease check if there is any email with the subject "{0}" in the spam mail folder, trash box, etc.',
      info5: 'If you have specified a domain, set it so that "{0}" can be received.',
    },
    ログイン画面へ: 'To the Login Screen',
  },
  // FE-CU55_Sorry画面 path: "/sorry","../pages/sorry/Index.vue
  FECU55Sorry画面: {
    ただいまシステムにつながりづらい状況です: 'Now, it is difficult to connect to the system.',
    ご利用の皆様にはご迷惑をおかけし申し訳ございません:
      'We apologize for any inconvenience this may cause.',
    お使いのブラウザは未対応のためご利用いただけません:
      'The browser you are using is not supported and cannot be used.',
    動作環境は以下の通りです: 'The operating requirement is as follows:',
    JavaScriptが無効です: 'JavaScript is disabled.',
    当サイトの利用にはJavaScriptの有効化が必要です: 'JavaScript must be enabled to use this site.',
    GoogleChrome: 'Google Chrome',
    WindowsAndroidMacOSiOS: '(Windows, Android, Mac OS, iOS)',
    MicrosoftEdge: 'Microsoft Edge',
    Windows: '(Windows)',
    SafariMacOSiOS: 'Safari(Mac OS, iOS)',
    指定されたページは存在しません: 'The specified page does not exist.',
    大変申し訳ございませんがお探しのページは削除されたかファイル名が間違っている可能性があります:
      'We are very sorry, but the page you are looking for may have been deleted or the file name may be incorrect.',
    アドレスを確認してください: 'Check the address.',
    ログイン画面へ移動: 'You will be redirected to the login screen after 15 seconds. Please ',
    こちら: 'click here',
    をクリックしてください: ' if you are not redirected automatically.',
  },
  // FC-CU56_利用規約画面 path: "/terms",pages/terms/Index.vue
  FECU56利用規約画面: {
    利用規約: 'Terms of Use',
    戻るボタン: 'Back',
  },
  // FE-CU57_プライバシーポリシー画面 path: "/privacy",pages/privacy/Index.vue
  FECU57プライバシーポリシー画面: {
    プライバシーポリシー: 'Privacy Policy',
    戻るボタン: 'Back',
  },
  // FE-CU58_利用規約・プライバシーポリシー同意画面 path: "/approvalTerms",pages/approvalTerms/ApprovalTerms.vue
  FECU58利用規約プライバシーポリシー同意画面: {
    利用規約プライバシーポリシー: 'Terms of Use and Privacy Policy',
    最後までお読みになり画面下部の利用規約に同意しますプライバシーポリシーに同意しますにチェックしてください:
      'Please read through and select the checkboxes of "I agree to the Terms of Use" and "I agree to the Privacy Policy" at the bottom of the screen.',
    ご注意: 'Caution',
    注意本文1: 'Home Security Service is a service for customers living in Japan.',
    注意本文2:
      'This service stores your registered information and image data in Japan.\nIf you reside outside Japan or the use of this service is subject to laws and regulations governing the transfer of personal information, etc., this service is not available. In addition, this service is not available if the use of this service is subject to the "Foreign Exchange and Foreign Trade Law" and other regulations relating to export controls under UN Security Council resolutions, or if the use of this service violates the Terms of Conditions of this contract, including prohibitions.',
    利用規約を読む: 'Read the Terms of Use',
    利用規約に同意します: 'I agree to the Terms of Use.',
    プライバシーポリシーを読む: 'Read the Privacy Policy',
    プライバシーポリシーに同意します: 'I agree to the Privacy Policy',
    次へボタン: 'Next',
    戻るボタン: 'Back',
    利用規約: 'Terms of Use',
    利用規約ダイアログー閉じるボタン: 'Close',
    プライバシーポリシー: 'Privacy Policy',
    プライバシーポリシーダイアログー閉じるボタン: 'Close',
  },
  // FE-CU59_ライセンス path: "/license",pages/license/Index.vue
  ライセンス: {
    ライセンス: 'License',
    戻るボタン: 'Back',
  },
  // FE-CU61_ショートカットアクション path: "/shortcutAction",pages/shortcutAction/Index.vue
  FECU61ショートカットアクション画面: {
    処理中: 'Processing... Please wait for a while.',
    成功: 'Security was deactivated.',
    E0001:
      'The area subject to the batch security operation is not set, or there is no security unit that you can operate.\nPlease apply the area subject to the batch security operation from the top screen.\n(Error Code: FE-CU61-E0001)',
    E0002:
      'Failed to communicate.\nPlease wait for a while and try again.\n(Error Code: FE-CU61-E0002)',
    E0003:
      'The transfer processing failed.\nPlease check the security status.\n(Error Code: FE-CU61-E0003)',
  },
  //components/modal/agreementDialog.vue
  agreementDialog: {
    確認: 'Confirm',
    いいえボタン: 'No',
    はいボタン: 'Yes',

    パスワードを変更します: 'Change the password.\nOK?',

    変更を承認します: 'Approve the changes.\nOK?',
    変更を否認しました:
      'The changes have been rejected.\nThe content of the changes has been cancelled.',

    入力された内容で登録します: 'The content you entered will be registered.\nOK?',
    入力された内容で仮登録します:
      'Provisional registration will be performed with the information you entered.\nOK?',
    入力された内容で仮登録を行います:
      'Provisional registration will be performed with the information you entered.\nOK?',
    入力された内容で変更します:
      'The current content will be changed with the content you entered.\nOK?',

    秘密の質問を変更します: 'Change your secret question.\nOK?',

    設定された内容で登録します: 'The content you entered will be registered. \nOK?',
    設定が完了していません: 'The setup is not complete. Do you want to move to the next screen?',
    設定された内容は全ての地区表示へ反映されます:
      'The content you entered will be reflected in all target areas.\nOK?',

    警備状態を変更します: 'Change the security status.\nOK?',
    ユーザー削除:
      'Delete user information because there are no target areas/cameras associated with this user. \nOK?',
  },
  agreementSelectDialog: {
    確認: 'Confirm',
    カメラを設置する地区を選択してください: 'Select the area where a camera will be installed.',
    戻る: 'Back',
    登録: 'Register',
  },
  messageDialog: {
    お知らせ: 'Announcement',
    完了: 'Finish',
    閉じる: 'Close',
    アプリの起動に失敗しました:
      'Failed to start the application.\nPress the phone number buttons again.',
    設定が完了しました: 'Setup is completed.',
    エラー: 'Error',
    OK: 'OK',
    ヘルプ: 'Help',
  },
  loadingDialog: {
    処理中です: 'Processing... Please wait for a while.',
    警備セット中: 'Security Activated Mode is in progress. Please wait for a while.',
    警備解除中: 'Security Deactivated Mode is in progress. Please wait for a while.',
  },
  tokenUpdateError: {
    title: 'Announcement',
    content: 'Your login has expired.\nPlease log in again.\n(Error Code: FE-CU2-E0001)',
  },
  requirePushNotificationPermission: {
    title: 'Announcement',
    content:
      'The PUSH notification setting on your smartphone or tablet is disabled.\nCheck the settings of your smartphone/tablet.',
    openSetting: 'Open Settings',
    keepStable: 'Use As It Is',
  },
  informationDialog: {
    タイトル: 'Announcement',
    閉じる: 'Close',
  },
  errorDialog: {
    タイトル: 'Announcement',
    閉じる: 'Close',
  },
  copyRight: 'Copyright © 2023 ALSOK. All rights reserved.',
};
